var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.page.network === "instagram" &&
    _vm.post.previewStoryMultipleScreenshotVideo
    ? _c("div", { staticClass: "preview-screenshot-multiple" }, [
        _c("video", {
          attrs: {
            src: _vm.post.previewStoryMultipleScreenshotVideo,
            controls: "",
          },
        }),
      ])
    : _vm.page.network === "instagram" &&
      _vm.post.previewStoryMultipleScreenshot
    ? _c("div", { staticClass: "preview-screenshot-multiple" }, [
        _c("img", {
          attrs: { src: _vm.post.previewStoryMultipleScreenshot, alt: "" },
        }),
      ])
    : _vm.page.network === "instagram" &&
      _vm.post._bots &&
      _vm.post._bots.mode === "story" &&
      _vm.post._bots.page &&
      _vm.post._bots.page.story_config &&
      _vm.post._bots.page.story_config.created &&
      _vm.post.status === "preview" &&
      _vm.post._bots.storyTemplate &&
      _vm.post._bots.storyTemplate.predefined
    ? _c("div", { staticClass: "template-preview" }, [
        _c("img", {
          staticClass: "template-img",
          attrs: { src: _vm.meta.og.images[0].url, alt: "" },
          on: { error: _vm.replaceByDefault },
        }),
        _c("img", {
          attrs: {
            src: `https://s3.eu-west-1.amazonaws.com/saas.mashup.sandbox/img/${_vm.post._bots.storyTemplate.predefined}.png`,
            alt: "",
          },
          on: { error: _vm.replaceByDefault },
        }),
        _c("p", [_vm._v(_vm._s(_vm.post.title))]),
        _c(
          "a",
          {
            staticClass: "link-container-2",
            attrs: { href: _vm.post.url, target: "_blank" },
          },
          [
            _c("img", {
              staticClass: "link-img-2",
              attrs: {
                src: require("../../assets/img/icon_instagram_link.svg"),
                alt: "Link",
              },
            }),
            _c("p", { staticClass: "link-txt-2" }, [
              _vm._v(_vm._s(_vm.post.url.split("/")[2].toUpperCase())),
            ]),
          ]
        ),
      ])
    : _vm.page.network === "instagram" &&
      _vm.post.status === "preview" &&
      !(
        _vm.post.screenshot ||
        (_vm.post.page &&
          _vm.post.page[0] &&
          (_vm.post.page[0].story || _vm.post.page[0].story_standard_api) &&
          JSON.parse(_vm.post.page[0].story).screenshot)
      ) &&
      ((_vm.post._bots &&
        _vm.post._bots[0] &&
        _vm.post._bots[0].mode === "story" &&
        _vm.post._bots[0].page &&
        _vm.post._bots[0].page.story_config &&
        _vm.post._bots[0].page.story_config.created) ||
        (_vm.post._bots &&
          _vm.post._bots.mode === "story" &&
          _vm.post._bots.page &&
          _vm.post._bots.page.story_config &&
          _vm.post._bots.page.story_config.created) ||
        (_vm.bot &&
          _vm.bot.page &&
          _vm.bot.mode === "story" &&
          _vm.bot.page.story_config &&
          _vm.bot.page.story_config.created)) &&
      ((_vm.post.page &&
        _vm.post.page[0] &&
        (_vm.post.page[0].story || _vm.post.page[0].story_standard_api) &&
        _vm.post.status === "scheduled") ||
        ["preview", "draft"].includes(_vm.post.status)) &&
      (_vm.post.enclosure ||
        (_vm.meta &&
          _vm.meta.og &&
          _vm.meta.og.images[0] &&
          _vm.meta.og.images[0].url))
    ? _c("component-template-maker", {
        attrs: {
          configuration:
            _vm.post._bots[0] && _vm.post._bots[0].storyTemplate
              ? _vm.post._bots[0].storyTemplate.configuration
              : _vm.post._bots && _vm.post._bots.storyTemplate
              ? _vm.post._bots.storyTemplate.configuration
              : _vm.bot.storyTemplate.configuration,
          image: _vm.post.enclosure || _vm.meta.og.images[0].url,
          title: _vm.post.title,
          link: _vm.post.url || null,
          preview: true,
        },
      })
    : ["instagram", "facebook"].includes(_vm.page.network) &&
      ((_vm.post.page &&
        _vm.post.page[0] &&
        (_vm.post.page[0].story || _vm.post.page[0].story_standard_api)) ||
        _vm.post.screenshot)
    ? _c(
        "div",
        { staticClass: "preview-post-story" },
        [
          _c("div", { staticClass: "user-info-story" }, [
            _c(
              "a",
              {
                class: !_vm.getPageUrl && "black-text",
                attrs: { href: _vm.getPageUrl || null, target: "blank" },
              },
              [
                _c("page-image-avatar", { attrs: { page: _vm.page } }),
                _c("span", [_vm._v(_vm._s(_vm.page.name))]),
              ],
              1
            ),
            _c("span", [_vm._v(_vm._s(_vm.dateFormat(_vm.postDate, true)))]),
          ]),
          _c("story", {
            class: !_vm.live && "storification-preview-size",
            attrs: {
              story: !(_vm.storificationObject || _vm.shareAfterPostPreview)
                ? {
                    image: _vm.imageStory,
                    video: _vm.videoStory,
                  }
                : undefined,
              storification:
                _vm.storificationObject || _vm.shareAfterPostPreview
                  ? {
                      image:
                        (_vm.carouselData &&
                          _vm.carouselData[0] &&
                          _vm.carouselData[0].url) ||
                        _vm.post.enclosure ||
                        _vm.image ||
                        (_vm.meta && _vm.meta.og && _vm.meta.og.image) ||
                        (_vm.meta &&
                          _vm.meta.og &&
                          _vm.meta.og.images &&
                          _vm.meta.images[0] &&
                          _vm.meta.images[0].url) ||
                        (_vm.meta &&
                          _vm.meta.images &&
                          _vm.meta.images[0] &&
                          _vm.meta.images[0].url),
                      username: _vm.storificationObject
                        ? _vm.storificationObject.username
                        : _vm.page.name,
                      isCarousel: _vm.storificationObject
                        ? _vm.storificationObject.isCarousel
                        : (_vm.multipleImages &&
                            _vm.multipleImages.length > 1) ||
                          (_vm.carouselData && _vm.carouselData.length > 1),
                      video:
                        _vm.videoStory ||
                        _vm.post.video ||
                        (_vm.post.page &&
                          _vm.post.page[0] &&
                          _vm.post.page[0].video) ||
                        (_vm.post.videos && _vm.post.videos["instagram_reel"]),
                      widgetsReel: {
                        texts: _vm.$store.getters.storificationTextsReel,
                        gifs: _vm.$store.getters.storificationGifsReel,
                        music: _vm.$store.getters.storificationMusicReel,
                      },
                    }
                  : undefined,
              backgroundColor: _vm.$store.getters.storificationBackgroundColor,
              link: {
                url: _vm.post.url,
                initialDatas: _vm.$store.getters.storificationLink,
                isActive: _vm.$store.getters.storificationLinkIsActive,
                text: _vm.$store.getters.storificationLinkText,
              },
              texts: _vm.$store.getters.storificationTexts,
              layers: _vm.$store.getters.storificationLayers,
              gifs: _vm.$store.getters.storificationGifs,
              music: _vm.$store.getters.storificationMusic,
              poll: _vm.$store.getters.storificationPoll,
              slider: _vm.$store.getters.storificationSlider,
              location: _vm.$store.getters.storificationLocation,
              product: _vm.$store.getters.storificationProduct,
              mentions: _vm.$store.getters.storificationMentions,
              hashtags: _vm.$store.getters.storificationHashtags,
              question: _vm.$store.getters.storificationQuestion,
              template: {
                config: _vm.$store.getters.storificationTemplate,
                custom: _vm.currentBot ? _vm.currentBot.storyTemplate : null,
              },
              preview: _vm.live
                ? null
                : {
                    Link: _vm.$store.getters.storificationLink,
                    Text: _vm.$store.getters.storificationTexts,
                    Layer: _vm.$store.getters.storificationLayers,
                    Gif: _vm.$store.getters.storificationGifs,
                    Poll: _vm.$store.getters.storificationPoll,
                    Slider: _vm.$store.getters.storificationSlider,
                    Mention: _vm.$store.getters.storificationMentions,
                    Hashtag: _vm.$store.getters.storificationHashtags,
                    Location: _vm.$store.getters.storificationLocation,
                    Product: _vm.$store.getters.storificationProduct,
                    Question: _vm.$store.getters.storificationQuestion,
                  },
              informations: {
                mentions: _vm.currentBot,
                acceptReplaceHashtag: _vm.activeHashtagsAutoAdd,
                validMentions: _vm.validMentions,
                validHashtags: _vm.validHashtags,
                acceptPrefix: _vm.activePrefixSuffix,
                pageInfo: _vm.page,
                highlight: _vm.highlightStoryEnable,
              },
            },
          }),
        ],
        1
      )
    : _vm.page.network === "facebook" &&
      _vm.post.page &&
      _vm.post.page[0] &&
      (_vm.post.page[0].story || _vm.post.page[0].story_standard_api)
    ? _c(
        "div",
        { staticClass: "preview-post-story" },
        [
          _c("div", { staticClass: "user-info-story" }, [
            _c(
              "a",
              {
                class: !_vm.getPageUrl && "black-text",
                attrs: { href: _vm.getPageUrl || null, target: "blank" },
              },
              [
                _c("page-image-avatar", { attrs: { page: _vm.page } }),
                _c("span", [_vm._v(_vm._s(_vm.page.name))]),
              ],
              1
            ),
            _c("span", [_vm._v(_vm._s(_vm.dateFormat(_vm.postDate, true)))]),
          ]),
          _vm.post.page[0].storification && _vm.typePost !== "story"
            ? _c("storification", {
                staticClass: "storification-preview-size",
                attrs: {
                  storification: {
                    image:
                      (_vm.post.page[0].carousel &&
                        _vm.post.page[0].carousel[0] &&
                        _vm.post.page[0].carousel[0].url) ||
                      _vm.post.page[0].enclosure ||
                      _vm.post.enclosure ||
                      _vm.image ||
                      (_vm.meta && _vm.meta.og && _vm.meta.og.image) ||
                      (_vm.meta &&
                        _vm.meta.og &&
                        _vm.meta.og.images &&
                        _vm.meta.images[0] &&
                        _vm.meta.images[0].url) ||
                      (_vm.meta &&
                        _vm.meta.images &&
                        _vm.meta.images[0] &&
                        _vm.meta.images[0].url),
                    username: _vm.page.name,
                    isCarousel:
                      _vm.post.page[0].carousel &&
                      _vm.post.page[0].carousel.length > 1,
                  },
                  link: {
                    url: _vm.post.url,
                    initialDatas:
                      (_vm.post.draft &&
                        _vm.post.draft.data.storificationData.link) ||
                      (_vm.post.page[0].storificationData &&
                        _vm.post.page[0].storificationData.link),
                    isActive:
                      (_vm.post.draft &&
                        _vm.post.draft.data.storificationData.link.active) ||
                      (_vm.post.page[0].storificationData &&
                        _vm.post.page[0].storificationData.link &&
                        _vm.post.page[0].storificationData.link.active),
                    text:
                      (_vm.post.draft &&
                        _vm.post.draft.data.storificationData.link.text) ||
                      (_vm.post.page[0].storificationData &&
                        _vm.post.page[0].storificationData.link &&
                        _vm.post.page[0].storificationData.link.text),
                  },
                  preview: _vm.live
                    ? null
                    : {
                        Link:
                          (_vm.post.draft &&
                            _vm.post.draft.data.storificationData.link) ||
                          (_vm.post.page[0].storificationData &&
                            _vm.post.page[0].storificationData.link),
                        Text:
                          (_vm.post.draft &&
                            _vm.post.draft.data.storificationData.texts) ||
                          (_vm.post.page[0].storificationData &&
                            _vm.post.page[0].storificationData.texts),
                        Layer:
                          (_vm.post.draft &&
                            _vm.post.draft.data.storificationData.layers) ||
                          (_vm.post.page[0].storificationData &&
                            _vm.post.page[0].storificationData.layers),
                        Gif:
                          (_vm.post.draft &&
                            _vm.post.draft.data.storificationData.gifs) ||
                          (_vm.post.page[0].storificationData &&
                            _vm.post.page[0].storificationData.gifs),
                        Poll:
                          (_vm.post.draft &&
                            _vm.post.draft.data.storificationData.poll) ||
                          (_vm.post.page[0].storificationData &&
                            _vm.post.page[0].storificationData.poll),
                        Slider:
                          (_vm.post.draft &&
                            _vm.post.draft.data.storificationData.mentions) ||
                          (_vm.post.page[0].storificationData &&
                            _vm.post.page[0].storificationData.slider),
                        Mention:
                          (_vm.post.draft &&
                            _vm.post.draft.data.storificationData.mentions) ||
                          (_vm.post.page[0].storificationData &&
                            _vm.post.page[0].storificationData.mentions),
                      },
                },
              })
            : _vm.post.page[0] &&
              _vm.post.page[0].story &&
              typeof _vm.post.page[0].story === "string" &&
              JSON.parse(_vm.post.page[0].story).texts[0] &&
              JSON.parse(_vm.post.page[0].story).texts[0].music &&
              _vm.post.page[0].video
            ? _c("video", {
                staticClass: "ratio story-video",
                attrs: { src: _vm.post.page[0].video, controls: "" },
                on: { loadedmetadata: _vm.videoRatio },
              })
            : _vm.post.page &&
              _vm.post.page[0] &&
              _vm.post.page[0].enclosure &&
              _vm.post.page[0].enclosure.slice(-4) === ".mp4"
            ? _c("video", {
                staticClass: "ratio story-video",
                attrs: { src: _vm.post.page[0].enclosure, controls: "" },
                on: { loadedmetadata: _vm.videoRatio },
              })
            : _vm.post.page[0] &&
              _vm.post.page[0].video &&
              _vm.post.page[0].video.slice(-4) === ".mp4"
            ? _c("video", {
                staticClass: "ratio story-video",
                attrs: { src: _vm.post.page[0].video, controls: "" },
                on: { loadedmetadata: _vm.videoRatio },
              })
            : _c("img", {
                attrs: {
                  src:
                    _vm.post.screenshot ||
                    JSON.parse(_vm.post.page[0].story).screenshot ||
                    _vm.post.page[0].enclosure,
                  alt: "preview",
                },
                on: { error: _vm.replaceByDefault },
              }),
        ],
        1
      )
    : _vm.page.network === "tiktok"
    ? _c(
        "div",
        {
          staticClass: "tiktok-video-container",
          on: {
            click: function ($event) {
              return _vm.getTiktokPageUrl(_vm.page.id)
            },
          },
        },
        [
          _c("div", { staticClass: "tiktok-video-screen" }, [
            _c("span", { staticClass: "tiktok-username" }, [
              _vm._v(_vm._s(`@${_vm.page.name}`)),
            ]),
            _vm._m(0),
            _c(
              "div",
              { staticClass: "tiktok-buttons" },
              [
                _c("vs-avatar", {
                  staticClass: "tiktok-avatar",
                  attrs: { size: "50px", src: _vm.page.avatar, alt: "page" },
                }),
                _c("img", {
                  attrs: {
                    src: require("../../assets/img/tiktok-iconbar.svg"),
                    alt: "",
                  },
                }),
                _c("vs-avatar", {
                  staticClass: "tiktok-avatar-music",
                  attrs: { size: "28px", src: _vm.page.avatar, alt: "page" },
                }),
              ],
              1
            ),
            _vm.post.videos && _vm.post.videos["tiktok"]
              ? _c("div", { staticClass: "tiktok-video" }, [
                  _c("video", {
                    staticClass: "ratio",
                    attrs: {
                      loop: "",
                      controls: "",
                      src: _vm.post.videos["tiktok"],
                    },
                    on: { loadedmetadata: _vm.videoRatio },
                  }),
                ])
              : _vm._e(),
            _vm.post.video &&
            typeof _vm.post.video === "string" &&
            _vm.post.video.includes("http")
              ? _c("div", { staticClass: "tiktok-video" }, [
                  _c("video", {
                    staticClass: "ratio",
                    attrs: { loop: "", controls: "", src: _vm.post.video },
                    on: { loadedmetadata: _vm.videoRatio },
                  }),
                ])
              : _vm.post.page && _vm.post.page[0] && _vm.post.page[0].video
              ? _c("div", { staticClass: "tiktok-video" }, [
                  _c("video", {
                    staticClass: "ratio",
                    attrs: {
                      loop: "",
                      controls: "",
                      src: _vm.post.page[0].video,
                    },
                    on: { loadedmetadata: _vm.videoRatio },
                  }),
                ])
              : _c("div", { staticClass: "tiktok-video no" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(_vm.$t("dash.message.no.video")) +
                      "\n    "
                  ),
                ]),
          ]),
        ]
      )
    : _vm.page.network === "instagram" &&
      (_vm.typePost == "video" ||
        (_vm.post.page && _vm.post.page[0] && _vm.post.page[0].video)) &&
      (_vm.videoReel ||
        _vm.post.videoReel ||
        (_vm.post.page && _vm.post.page[0] && _vm.post.page[0].videoReel))
    ? _c(
        "div",
        {
          staticClass: "reel-container",
          class: [
            { lorem: _vm.post.title == "" && !_vm.moderation, live: _vm.live },
          ],
        },
        [
          _vm.moderation && !["telegram"].includes(_vm.page.network)
            ? _c(
                "p",
                {
                  staticClass: "date",
                  on: {
                    click: function ($event) {
                      $event.preventDefault()
                      _vm.live &&
                      !_vm.activeEdit.scheduling &&
                      _vm.isUserPremiumActive
                        ? _vm.showEditPost("scheduling")
                        : null
                    },
                  },
                },
                [
                  _c(
                    "Tooltip",
                    {
                      attrs: {
                        text: _vm.dateFormat(_vm.post.date),
                        position: "top",
                      },
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.dateFromNow(_vm.post.date))),
                      ]),
                      _vm._v("\n       \n    "),
                    ]
                  ),
                ],
                1
              )
            : !["telegram"].includes(_vm.page.network)
            ? _c("p", { staticClass: "date" }, [
                _vm._v("\n    " + _vm._s(_vm.postDate) + "\n    "),
                _vm.live && !_vm.doScreenshot
                  ? _c(
                      "span",
                      { staticClass: "btn-edit" },
                      [
                        _c(
                          "Tooltip",
                          {
                            attrs: {
                              text: _vm.$t("dash.post.overlay.edit.date"),
                              position: "top",
                            },
                          },
                          [
                            _c("vs-button", {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value:
                                    _vm.live &&
                                    !_vm.activeEdit.scheduling &&
                                    _vm.isUserPremiumActive,
                                  expression:
                                    "live && !activeEdit.scheduling && isUserPremiumActive",
                                },
                              ],
                              staticClass: "button-reel-edit",
                              attrs: { "vs-type": "filled", icon: "edit" },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  return _vm.showEditPost("scheduling")
                                },
                              },
                            }),
                            _vm._v("\n          \n      "),
                          ],
                          1
                        ),
                      ],
                      1
                    )
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.live &&
          _vm.activeEdit.scheduling &&
          !["telegram"].includes(_vm.page.network)
            ? _c("div", { staticClass: "live-scheduling schedule" }, [
                _c("div", { staticClass: "schedule-wrapper" }, [
                  _c(
                    "div",
                    { staticClass: "edit-scheduling" },
                    [
                      _c("component-datepicker", {
                        staticClass: "posts-datepicker",
                        attrs: {
                          date: new Date(_vm.editValue.scheduling.date),
                          now: true,
                        },
                        on: { picked: _vm.picked },
                      }),
                      _c(
                        "div",
                        { staticClass: "posts-timepicker" },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/icon_time_black.svg"),
                              alt: "time",
                            },
                          }),
                          _c("vue-timepicker", {
                            attrs: {
                              "hour-range": _vm.rangeHour,
                              "minute-range": _vm.rangeMinute,
                              "auto-scroll": "",
                              "minute-interval": _vm.minuteInterval,
                            },
                            on: { change: _vm.changeRangeSchedulingTime },
                            model: {
                              value: _vm.editValue.scheduling.time,
                              callback: function ($$v) {
                                _vm.$set(_vm.editValue.scheduling, "time", $$v)
                              },
                              expression: "editValue.scheduling.time",
                            },
                          }),
                        ],
                        1
                      ),
                      _c("vs-button", {
                        attrs: { "vs-type": "filled", icon: "close" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.activeEdit.scheduling = false
                          },
                        },
                      }),
                      _c("vs-button", {
                        attrs: { "vs-type": "filled", icon: "check" },
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            return _vm.editPost("scheduling")
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          (_vm.post.video &&
            typeof _vm.post.video === "string" &&
            _vm.post.video.includes("http")) ||
          (_vm.post.page && _vm.post.page[0] && _vm.post.page[0].video) ||
          (_vm.post.videos && _vm.post.videos["instagram_reel"])
            ? _c(
                "div",
                {
                  staticClass: "reel",
                  class: !_vm.live && "storification-preview-size",
                },
                [
                  _c("story", {
                    attrs: {
                      story: {
                        video: _vm.videoStory,
                        isReel: true,
                        enclosure:
                          ["instagram"].includes(_vm.page.network) &&
                          (_vm.image ||
                            (_vm.post.page &&
                              _vm.post.page[0] &&
                              _vm.post.page[0].enclosure))
                            ? _vm.image || _vm.post.page[0].enclosure
                            : null,
                      },
                      texts: _vm.$store.getters.storificationTextsReel,
                      gifs: _vm.$store.getters.storificationGifsReel,
                      music: _vm.$store.getters.storificationMusicReel,
                      preview: _vm.live
                        ? null
                        : {
                            Text: _vm.$store.getters.storificationTextsReel,
                            Gif: _vm.$store.getters.storificationGifsReel,
                          },
                      informations: {
                        mentions: _vm.currentBot,
                        acceptReplaceHashtag: _vm.activeHashtagsAutoAdd,
                        validMentions: _vm.validMentions,
                        validHashtags: _vm.validHashtags,
                        acceptPrefix: _vm.activePrefixSuffix,
                        pageInfo: _vm.page,
                        highlight: _vm.highlightStoryEnable,
                      },
                    },
                  }),
                  !(
                    _vm.$store.getters.storificationMusicReel &&
                    _vm.$store.getters.storificationMusicReel.config
                  )
                    ? _c("div", { staticClass: "reel-cta" }, [
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "_8-yf5",
                              attrs: {
                                "aria-label": "J’aime",
                                fill: "#FFF",
                                height: "24",
                                viewBox: "0 0 48 48",
                                width: "24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M34.6 6.1c5.7 0 10.4 5.2 10.4 11.5 0 6.8-5.9 11-11.5 16S25 41.3 24 41.9c-1.1-.7-4.7-4-9.5-8.3-5.7-5-11.5-9.2-11.5-16C3 11.3 7.7 6.1 13.4 6.1c4.2 0 6.5 2 8.1 4.3 1.9 2.6 2.2 3.9 2.5 3.9.3 0 .6-1.3 2.5-3.9 1.6-2.3 3.9-4.3 8.1-4.3m0-3c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5.6 0 1.1-.2 1.6-.5 1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "_8-yf5",
                              attrs: {
                                "aria-label": "Commenter",
                                fill: "#FFF",
                                height: "24",
                                viewBox: "0 0 48 48",
                                width: "24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "clip-rule": "evenodd",
                                  d: "M47.5 46.1l-2.8-11c1.8-3.3 2.8-7.1 2.8-11.1C47.5 11 37 .5 24 .5S.5 11 .5 24 11 47.5 24 47.5c4 0 7.8-1 11.1-2.8l11 2.8c.8.2 1.6-.6 1.4-1.4zm-3-22.1c0 4-1 7-2.6 10-.2.4-.3.9-.2 1.4l2.1 8.4-8.3-2.1c-.5-.1-1-.1-1.4.2-1.8 1-5.2 2.6-10 2.6-11.4 0-20.6-9.2-20.6-20.5S12.7 3.5 24 3.5 44.5 12.7 44.5 24z",
                                  "fill-rule": "evenodd",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "_8-yf5",
                              attrs: {
                                "aria-label": "Partager la publication",
                                fill: "#FFF",
                                height: "24",
                                viewBox: "0 0 48 48",
                                width: "24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M47.8 3.8c-.3-.5-.8-.8-1.3-.8h-45C.9 3.1.3 3.5.1 4S0 5.2.4 5.7l15.9 15.6 5.5 22.6c.1.6.6 1 1.2 1.1h.2c.5 0 1-.3 1.3-.7l23.2-39c.4-.4.4-1 .1-1.5zM5.2 6.1h35.5L18 18.7 5.2 6.1zm18.7 33.6l-4.4-18.4L42.4 8.6 23.9 39.7z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [_vm._v(". . .")]),
                      ])
                    : _vm._e(),
                  !(
                    _vm.$store.getters.storificationMusicReel &&
                    _vm.$store.getters.storificationMusicReel.config
                  )
                    ? _c("div", { staticClass: "reel-background" })
                    : _vm._e(),
                  !(
                    _vm.$store.getters.storificationMusicReel &&
                    _vm.$store.getters.storificationMusicReel.config
                  )
                    ? _c(
                        "a",
                        {
                          staticClass: "reel-avatar",
                          class: !_vm.getPageUrl && "black-text",
                          attrs: {
                            href: _vm.getPageUrl || null,
                            target: "blank",
                          },
                        },
                        [
                          _c("page-image-avatar", {
                            attrs: { page: _vm.page },
                          }),
                          _c("p", { staticClass: "page-name" }, [
                            _vm._v(_vm._s(`${_vm.page.name}`)),
                          ]),
                          _c("p", { staticClass: "reel-follow" }, [
                            _vm._v("Suivre"),
                          ]),
                        ],
                        1
                      )
                    : _vm._e(),
                  !(
                    _vm.$store.getters.storificationMusicReel &&
                    _vm.$store.getters.storificationMusicReel.config
                  )
                    ? _c(
                        "div",
                        {
                          staticClass: "title reel-title",
                          class: [
                            {
                              lorem: _vm.post.title == "" && !_vm.moderation,
                              live: _vm.live,
                            },
                          ],
                        },
                        [
                          !_vm.activeEdit.title
                            ? _c(
                                "div",
                                {
                                  staticClass: "title-cont",
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.live && !_vm.activeEdit.title
                                        ? _vm.showEditPost("title")
                                        : null
                                    },
                                  },
                                },
                                [
                                  _vm.activePrefixSuffix &&
                                  _vm.bot &&
                                  _vm.bot.hashtagPrefix &&
                                  _vm.post.title != ""
                                    ? _c("span", {
                                        staticClass: "hashtag-prefix",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            `${_vm.addHashtagsLinks(
                                              _vm.bot.hashtagPrefix
                                            )} `
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                  _c("span", {
                                    domProps: {
                                      innerHTML: _vm._s(
                                        _vm.handleNewLine(
                                          _vm
                                            .getMessageToPost(_vm.post)
                                            .slice(0, 80)
                                        )
                                      ),
                                    },
                                  }),
                                  _vm._v(
                                    _vm._s(
                                      _vm.getMessageToPost(_vm.post).length > 80
                                        ? "..."
                                        : ""
                                    ) + "\n          "
                                  ),
                                  _vm.activePrefixSuffix &&
                                  _vm.bot &&
                                  _vm.bot.hashtag &&
                                  _vm.post.title != ""
                                    ? _c("span", {
                                        staticClass: "hashtag-suffix",
                                        domProps: {
                                          innerHTML: _vm._s(
                                            ` ${_vm.addHashtagsLinks(
                                              _vm.bot.hashtag
                                            )}`
                                          ),
                                        },
                                      })
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                          _vm.live && !_vm.doScreenshot && _vm.post.title != ""
                            ? _c("div", { staticClass: "live-title" }, [
                                _c(
                                  "span",
                                  { staticClass: "btn-edit" },
                                  [
                                    _c(
                                      "Tooltip",
                                      {
                                        attrs: {
                                          text: _vm.$t(
                                            "dash.post.overlay.edit.message"
                                          ),
                                          position: "top",
                                        },
                                      },
                                      [
                                        _c("vs-button", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: !_vm.activeEdit.title,
                                              expression: "!activeEdit.title",
                                            },
                                          ],
                                          staticClass: "button-reel-edit",
                                          attrs: {
                                            "vs-type": "filled",
                                            icon: "edit",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.showEditPost("title")
                                            },
                                          },
                                        }),
                                        _vm._v(
                                          "\n                \n            "
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _vm.activeEdit.title
                                  ? _c("div", { staticClass: "edit-title" }, [
                                      _c(
                                        "div",
                                        {
                                          directives: [
                                            {
                                              name: "click-outside",
                                              rawName: "v-click-outside",
                                              value: _vm.hideEmojiPicker,
                                              expression: "hideEmojiPicker",
                                            },
                                          ],
                                          staticClass: "textarea-emoji-picker",
                                        },
                                        [
                                          _vm.page.network !== "bluesky"
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "styles-text-buttons",
                                                },
                                                [
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "emoji-trigger",
                                                      class: {
                                                        triggered: _vm
                                                          .styledText()
                                                          .includes("bold"),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.styleSelection(
                                                            "bold"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            viewBox:
                                                              "0 0 20 20",
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              fill: "#888888",
                                                              d: "M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "emoji-trigger",
                                                      class: {
                                                        triggered: _vm
                                                          .styledText()
                                                          .includes("italic"),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.styleSelection(
                                                            "italic"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            viewBox:
                                                              "0 0 20 20",
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              fill: "#888888",
                                                              d: "M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z ",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                  _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "emoji-trigger",
                                                      class: {
                                                        triggered: _vm
                                                          .styledText()
                                                          .includes(
                                                            "underline"
                                                          ),
                                                      },
                                                      on: {
                                                        click: function (
                                                          $event
                                                        ) {
                                                          return _vm.styleSelection(
                                                            "underline"
                                                          )
                                                        },
                                                      },
                                                    },
                                                    [
                                                      _c(
                                                        "svg",
                                                        {
                                                          attrs: {
                                                            viewBox:
                                                              "0 0 20 20",
                                                            xmlns:
                                                              "http://www.w3.org/2000/svg",
                                                          },
                                                        },
                                                        [
                                                          _c("path", {
                                                            attrs: {
                                                              fill: "#888888",
                                                              d: "M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z",
                                                            },
                                                          }),
                                                          _c("path", {
                                                            attrs: {
                                                              fill: "#888888",
                                                              d: "M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z",
                                                            },
                                                          }),
                                                        ]
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _vm.page.network !== "bluesky"
                                            ? _c("picker", {
                                                directives: [
                                                  {
                                                    name: "show",
                                                    rawName: "v-show",
                                                    value: _vm.showEmojiPicker,
                                                    expression:
                                                      "showEmojiPicker",
                                                  },
                                                ],
                                                attrs: {
                                                  data: _vm.emojiIndex,
                                                  title: "Pick your emoji...",
                                                  emoji: "point_up",
                                                },
                                                on: { select: _vm.addEmoji },
                                              })
                                            : _vm._e(),
                                          _vm.page.network !== "bluesky"
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass: "emoji-trigger",
                                                  class: {
                                                    triggered:
                                                      _vm.showEmojiPicker,
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.toggleEmojiPicker,
                                                  },
                                                },
                                                [
                                                  _c(
                                                    "svg",
                                                    {
                                                      staticStyle: {
                                                        width: "20px",
                                                        height: "20px",
                                                      },
                                                      attrs: {
                                                        viewBox: "0 0 24 24",
                                                      },
                                                    },
                                                    [
                                                      _c("path", {
                                                        attrs: {
                                                          fill: "#888888",
                                                          d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                        },
                                                      }),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass: "add-mention",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleShowMentions(
                                                    "Mention"
                                                  )
                                                },
                                              },
                                            },
                                            [_vm._v("@")]
                                          ),
                                          _vm.activeSearchHashtags
                                            ? _c(
                                                "span",
                                                {
                                                  staticClass:
                                                    "add-mention add-hashtag",
                                                  on: {
                                                    click: function ($event) {
                                                      return _vm.toggleShowMentions(
                                                        "Hashtag"
                                                      )
                                                    },
                                                  },
                                                },
                                                [_vm._v("#")]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "span",
                                            {
                                              staticClass:
                                                "add-mention ai-generate",
                                              on: {
                                                click: function ($event) {
                                                  return _vm.getAccrochesByAI()
                                                },
                                              },
                                            },
                                            [
                                              _c(
                                                "span",
                                                {
                                                  staticClass: "material-icons",
                                                },
                                                [_vm._v("lightbulb_outline")]
                                              ),
                                            ]
                                          ),
                                          _c("vs-button", {
                                            staticClass: "close button-reel",
                                            attrs: {
                                              "vs-type": "filled",
                                              icon: "close",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                _vm.activeEdit.title = false
                                              },
                                            },
                                          }),
                                          _c("vs-button", {
                                            staticClass: "save button-reel",
                                            attrs: {
                                              "vs-type": "filled",
                                              icon: "check",
                                            },
                                            on: {
                                              click: function ($event) {
                                                $event.preventDefault()
                                                return _vm.editPost("title")
                                              },
                                            },
                                          }),
                                          _c("vs-textarea", {
                                            ref: `inputTitle-${_vm.page.network_id}`,
                                            class: { input: true },
                                            attrs: {
                                              "vs-size": "large",
                                              color: "#B20564",
                                              name: "title",
                                              placeholder: _vm.$t(
                                                "dash.posts.overlay.description_placeholder"
                                              ),
                                              id: `inputTitle-${_vm.page.network_id}`,
                                            },
                                            on: {
                                              click: function ($event) {
                                                ;[_vm.checkAddMention()]
                                              },
                                              keyup: function ($event) {
                                                ;[
                                                  _vm.checkTruncate(),
                                                  _vm.checkAddMention(),
                                                  _vm.textAreaAdjust(
                                                    `inputTitle-${_vm.page.network_id}`
                                                  ),
                                                ]
                                              },
                                            },
                                            model: {
                                              value: _vm.editValue.title,
                                              callback: function ($$v) {
                                                _vm.$set(
                                                  _vm.editValue,
                                                  "title",
                                                  $$v
                                                )
                                              },
                                              expression: "editValue.title",
                                            },
                                          }),
                                          _vm.limitText()
                                            ? _c(
                                                "div",
                                                {
                                                  staticClass:
                                                    "vs-textarea--count",
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                " +
                                                      _vm._s(
                                                        _vm.sizeCurrentMessage()
                                                      ) +
                                                      " / " +
                                                      _vm._s(_vm.limitText()) +
                                                      "\n              "
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                        ],
                                        1
                                      ),
                                    ])
                                  : _vm._e(),
                              ])
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          (_vm.post.video &&
            typeof _vm.post.video === "string" &&
            _vm.post.video.includes("http")) ||
          (_vm.post.page && _vm.post.page[0] && _vm.post.page[0].video) ||
          (_vm.post.videos && _vm.post.videos["instagram_reel"])
            ? _c("div", { staticClass: "text-reel" }, [
                !_vm.activeEdit.title
                  ? _c(
                      "div",
                      {
                        staticClass: "title-cont",
                        on: {
                          click: function ($event) {
                            $event.preventDefault()
                            _vm.live && !_vm.activeEdit.title
                              ? _vm.showEditPost("title")
                              : null
                          },
                        },
                      },
                      [
                        _vm.activePrefixSuffix &&
                        _vm.bot &&
                        _vm.bot.hashtagPrefix &&
                        _vm.post.title != ""
                          ? _c("span", {
                              staticClass: "hashtag-prefix",
                              domProps: {
                                innerHTML: _vm._s(
                                  `${_vm.addHashtagsLinks(
                                    _vm.bot.hashtagPrefix
                                  )} `
                                ),
                              },
                            })
                          : _vm._e(),
                        _c("span", {
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.handleNewLine(
                                _vm.getMessageToPost(_vm.post).slice(0, 80)
                              )
                            ),
                          },
                        }),
                        _vm._v(
                          _vm._s(
                            _vm.getMessageToPost(_vm.post).length > 80
                              ? "..."
                              : ""
                          ) + "\n      "
                        ),
                        _vm.activePrefixSuffix &&
                        _vm.bot &&
                        _vm.bot.hashtag &&
                        _vm.post.title != ""
                          ? _c("span", {
                              staticClass: "hashtag-suffix",
                              domProps: {
                                innerHTML: _vm._s(
                                  ` ${_vm.addHashtagsLinks(_vm.bot.hashtag)}`
                                ),
                              },
                            })
                          : _vm._e(),
                      ]
                    )
                  : _vm._e(),
                _vm.live && !_vm.doScreenshot && _vm.post.title != ""
                  ? _c("div", { staticClass: "live-title" }, [
                      _c(
                        "span",
                        { staticClass: "btn-edit" },
                        [
                          _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.$t("dash.post.overlay.edit.message"),
                                position: "top",
                              },
                            },
                            [
                              _c("vs-button", {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: !_vm.activeEdit.title,
                                    expression: "!activeEdit.title",
                                  },
                                ],
                                staticClass: "button-reel-edit",
                                attrs: { "vs-type": "filled", icon: "edit" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.showEditPost("title")
                                  },
                                },
                              }),
                              _vm._v("\n            \n        "),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ])
                  : _vm._e(),
              ])
            : _vm._e(),
          _vm.page.network === "instagram" &&
          _vm.shareAfterPost &&
          _vm.page.story_config &&
          _vm.page.story_config.created
            ? _c(
                "div",
                [
                  _vm._m(1),
                  _c("story", {
                    class: !_vm.live && "storification-preview-size",
                    attrs: {
                      storification: {
                        video:
                          _vm.post.video ||
                          (_vm.multipleMedias &&
                            _vm.multipleMedias[0] &&
                            _vm.multipleMedias[0].type.includes("video") &&
                            _vm.multipleMedias[0].url),
                        image: _vm.post.enclosure,
                        username: _vm.page.name,
                        isCarousel:
                          _vm.multipleImages && _vm.multipleImages.length > 1,
                        widgetsReel: {
                          texts: _vm.$store.getters.storificationTextsReel,
                          gifs: _vm.$store.getters.storificationGifsReel,
                          music: _vm.$store.getters.storificationMusicReel,
                        },
                      },
                      backgroundColor:
                        _vm.$store.getters.storificationBackgroundColor,
                      link: {
                        url: _vm.post.url,
                        initialDatas: _vm.$store.getters.storificationLink,
                        isActive: _vm.$store.getters.storificationLinkIsActive,
                        text: _vm.$store.getters.storificationLinkText,
                      },
                      texts: _vm.$store.getters.storificationTexts,
                      gifs: _vm.$store.getters.storificationGifs,
                      music: _vm.$store.getters.storificationMusic,
                      layers: _vm.$store.getters.storificationLayers,
                      location: _vm.$store.getters.storificationLocation,
                      product: _vm.$store.getters.storificationProduct,
                      poll: _vm.$store.getters.storificationPoll,
                      slider: _vm.$store.getters.storificationSlider,
                      mentions: _vm.$store.getters.storificationMentions,
                      hashtags: _vm.$store.getters.storificationHashtags,
                      question: _vm.$store.getters.storificationQuestion,
                      template: {
                        config: _vm.$store.getters.storificationTemplate,
                        custom: _vm.currentBot
                          ? _vm.currentBot.storyTemplate
                          : null,
                      },
                      preview: _vm.live
                        ? null
                        : {
                            Link: _vm.$store.getters.storificationLink,
                            Text: _vm.$store.getters.storificationTexts,
                            Layer: _vm.$store.getters.storificationLayers,
                            Gif: _vm.$store.getters.storificationGifs,
                            Poll: _vm.$store.getters.storificationPoll,
                            Slider: _vm.$store.getters.storificationSlider,
                            Mention: _vm.$store.getters.storificationMentions,
                            Hashtag: _vm.$store.getters.storificationHashtags,
                            Location: _vm.$store.getters.storificationLocation,
                            Product: _vm.$store.getters.storificationProduct,
                            Question: _vm.$store.getters.storificationQuestion,
                          },
                      informations: {
                        mentions: _vm.currentBot,
                        acceptReplaceHashtag: _vm.activeHashtagsAutoAdd,
                        validMentions: _vm.validMentions,
                        validHashtags: _vm.validHashtags,
                        acceptPrefix: _vm.activePrefixSuffix,
                        pageInfo: _vm.page,
                        highlight: _vm.highlightStoryEnable,
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.page.network === "instagram" &&
          _vm.storyShareToFacebook &&
          _vm.page.story_config &&
          _vm.page.story_config.created
            ? _c(
                "div",
                [
                  _vm._m(2),
                  _c("story", {
                    class: !_vm.live && "storification-preview-size",
                    attrs: {
                      storification: {
                        video:
                          _vm.post.video ||
                          (_vm.multipleMedias &&
                            _vm.multipleMedias[0] &&
                            _vm.multipleMedias[0].type.includes("video") &&
                            _vm.multipleMedias[0].url),
                        image: _vm.post.enclosure,
                        username: _vm.page.name,
                        isCarousel:
                          _vm.multipleImages && _vm.multipleImages.length > 1,
                        widgetsReel: {
                          texts: _vm.$store.getters.storificationTextsReel,
                          gifs: _vm.$store.getters.storificationGifsReel,
                          music: _vm.$store.getters.storificationMusicReel,
                        },
                      },
                      backgroundColor:
                        _vm.$store.getters.storificationBackgroundColor,
                      link: {
                        url: _vm.post.url,
                        initialDatas: _vm.$store.getters.storificationLink,
                        isActive: _vm.$store.getters.storificationLinkIsActive,
                        text: _vm.$store.getters.storificationLinkText,
                      },
                      texts: _vm.$store.getters.storificationTexts,
                      layers: _vm.$store.getters.storificationLayers,
                      location: _vm.$store.getters.storificationLocation,
                      gifs: _vm.$store.getters.storificationGifs,
                      music: _vm.$store.getters.storificationMusic,
                      product: _vm.$store.getters.storificationProduct,
                      poll: _vm.$store.getters.storificationPoll,
                      slider: _vm.$store.getters.storificationSlider,
                      mentions: _vm.$store.getters.storificationMentions,
                      hashtags: _vm.$store.getters.storificationHashtags,
                      question: _vm.$store.getters.storificationQuestion,
                      template: {
                        config: _vm.$store.getters.storificationTemplate,
                        custom: _vm.currentBot
                          ? _vm.currentBot.storyTemplate
                          : null,
                      },
                      preview: {
                        Link: _vm.$store.getters.storificationLink,
                        Text: _vm.$store.getters.storificationTexts,
                        Layer: _vm.$store.getters.storificationLayers,
                        Gif: _vm.$store.getters.storificationGifs,
                        Poll: _vm.$store.getters.storificationPoll,
                        Slider: _vm.$store.getters.storificationSlider,
                        Mention: _vm.$store.getters.storificationMentions,
                        Hashtag: _vm.$store.getters.storificationHashtags,
                        Location: _vm.$store.getters.storificationLocation,
                        Product: _vm.$store.getters.storificationProduct,
                        Question: _vm.$store.getters.storificationQuestion,
                      },
                      informations: {
                        mentions: _vm.currentBot,
                        acceptReplaceHashtag: _vm.activeHashtagsAutoAdd,
                        validMentions: _vm.validMentions,
                        validHashtags: _vm.validHashtags,
                        acceptPrefix: _vm.activePrefixSuffix,
                        pageInfo: _vm.page,
                        highlight: _vm.highlightStoryEnable,
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      )
    : _c(
        "div",
        { staticClass: "post preview", class: _vm.page.network },
        [
          _vm.live &&
          !_vm.doScreenshot &&
          ((_vm.editPostValue &&
            _vm.editPostValue.find((p) => p.page == _vm.page.id)) ||
            _vm.checkEditImage())
            ? _c("div", { staticClass: "customized" }, [
                _c(
                  "div",
                  [
                    _c(
                      "Tooltip",
                      {
                        attrs: {
                          text: _vm.$t("dash.posts.customized.detail"),
                          position: "top",
                        },
                      },
                      [
                        _vm._v(
                          "\n        " +
                            _vm._s(_vm.$t("dash.posts.customized")) +
                            "\n        "
                        ),
                        _c("vs-button", {
                          attrs: { "vs-type": "filled", icon: "close" },
                          on: { click: _vm.removeCustomized },
                        }),
                        _vm._v("\n         \n      "),
                      ],
                      1
                    ),
                  ],
                  1
                ),
              ])
            : _vm._e(),
          _vm.retweet
            ? _c("div", { staticClass: "retweet" }, [
                _c(
                  "svg",
                  {
                    staticClass:
                      "r-14j79pv r-4qtqp9 r-yyyyoo r-10ptun7 r-dnmrzs r-bnwqim r-1plcrui r-lrvibr r-1janqcz",
                    attrs: { viewBox: "0 0 24 24", "aria-hidden": "true" },
                  },
                  [
                    _c("g", [
                      _c("path", {
                        attrs: {
                          d: "M23.615 15.477c-.47-.47-1.23-.47-1.697 0l-1.326 1.326V7.4c0-2.178-1.772-3.95-3.95-3.95h-5.2c-.663 0-1.2.538-1.2 1.2s.537 1.2 1.2 1.2h5.2c.854 0 1.55.695 1.55 1.55v9.403l-1.326-1.326c-.47-.47-1.23-.47-1.697 0s-.47 1.23 0 1.697l3.374 3.375c.234.233.542.35.85.35s.613-.116.848-.35l3.375-3.376c.467-.47.467-1.23-.002-1.697zM12.562 18.5h-5.2c-.854 0-1.55-.695-1.55-1.55V7.547l1.326 1.326c.234.235.542.352.848.352s.614-.117.85-.352c.468-.47.468-1.23 0-1.697L5.46 3.8c-.47-.468-1.23-.468-1.697 0L.388 7.177c-.47.47-.47 1.23 0 1.697s1.23.47 1.697 0L3.41 7.547v9.403c0 2.178 1.773 3.95 3.95 3.95h5.2c.664 0 1.2-.538 1.2-1.2s-.535-1.2-1.198-1.2z",
                        },
                      }),
                    ]),
                  ]
                ),
                _c("p", { staticClass: "page-name" }, [
                  _vm._v(
                    _vm._s(_vm.retweet.name) +
                      " " +
                      _vm._s(_vm.$t("dash.posts.retweeted"))
                  ),
                ]),
              ])
            : _vm._e(),
          _c("div", { staticClass: "align-items-horiz" }, [
            _c("div", { staticClass: "page", class: { live: _vm.live } }, [
              _c(
                "a",
                {
                  class: !_vm.getPageUrl && "black-text",
                  attrs: { href: _vm.getPageUrl || null, target: "blank" },
                },
                [
                  _c("page-image-avatar", { attrs: { page: _vm.page } }),
                  _vm.page.network === "instagram" &&
                  ((_vm.userTags &&
                    _vm.userTags.collab &&
                    _vm.userTags.collab.length) ||
                    (_vm.post.userTags &&
                      _vm.post.userTags.collab &&
                      _vm.post.userTags.collab.length))
                    ? _c("p", { staticClass: "page-name" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.userTags
                                ? `${_vm.page.name} et ${_vm.userTags.list
                                    .filter((e) =>
                                      _vm.userTags.collab.includes(e.id)
                                    )
                                    .map((e) => e.username)
                                    .join(" et ")}`
                                : `${_vm.page.name} et ${_vm.post.userTags.list
                                    .filter((e) =>
                                      _vm.post.userTags.collab.includes(e.id)
                                    )
                                    .map((e) => e.username)
                                    .join(" et ")}`
                            ) +
                            "        \n        "
                        ),
                      ])
                    : _vm.page.network === "instagram" &&
                      _vm.post.page &&
                      _vm.post.page[0] &&
                      _vm.post.page[0].userTags &&
                      JSON.parse(_vm.post.page[0].userTags).collab &&
                      JSON.parse(_vm.post.page[0].userTags).collab.length
                    ? _c("p", { staticClass: "page-name" }, [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              `${_vm.page.name} et ${JSON.parse(
                                _vm.post.page[0].userTags
                              )
                                .list.filter((e) =>
                                  JSON.parse(
                                    _vm.post.page[0].userTags
                                  ).collab.includes(e.id)
                                )
                                .map((e) => e.username)
                                .join(" et ")}`
                            ) +
                            "        \n        "
                        ),
                      ])
                    : _c("p", { staticClass: "page-name" }, [
                        _vm._v(
                          _vm._s(
                            `${_vm.page.network === "twitter" ? "@" : ""}${
                              _vm.page.name
                            }`
                          )
                        ),
                      ]),
                ],
                1
              ),
              _vm.page.network === "instagram" &&
              (_vm.location || _vm.post.location)
                ? _c("p", { staticClass: "location-preview" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.location
                            ? _vm.location.instagram
                              ? _vm.location.instagram.name
                              : _vm.location.name
                            : _vm.post.location.instagram
                            ? _vm.post.location.instagram.name
                            : _vm.post.location.name
                        ) +
                        "        \n      "
                    ),
                  ])
                : _vm._e(),
              _vm.page.network === "instagram" &&
              _vm.typePost === "image" &&
              _vm.$store.getters.storificationMusic &&
              (_vm.$store.getters.storificationMusic.track ||
                _vm.$store.getters.storificationMusic.original_sound)
                ? _c("p", { staticClass: "location-preview" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.$store.getters.storificationMusic.track
                            .display_artist
                        ) +
                        " . " +
                        _vm._s(
                          _vm.$store.getters.storificationMusic.track.title
                        ) +
                        "      \n      "
                    ),
                  ])
                : _vm.page.network === "facebook" &&
                  (_vm.location || _vm.post.location)
                ? _c("p", { staticClass: "location-preview" }, [
                    _c("span", [
                      _vm._v(
                        _vm._s(_vm.$t("dash.post.preview.location.is_to"))
                      ),
                    ]),
                    _vm._v(
                      " " +
                        _vm._s(
                          _vm.location
                            ? _vm.location.facebook
                              ? _vm.location.facebook.name
                              : _vm.location.name
                            : _vm.post.location.facebook
                            ? _vm.post.location.facebook.name
                            : _vm.post.location.name
                        ) +
                        "        \n      "
                    ),
                  ])
                : ["instagram", "facebook"].includes(_vm.page.network) &&
                  _vm.post.page &&
                  _vm.post.page[0] &&
                  _vm.post.page[0].location
                ? _c("p", { staticClass: "location-preview" }, [
                    _vm.page.network == "facebook"
                      ? _c("span", [
                          _vm._v(
                            _vm._s(_vm.$t("dash.post.preview.location.is_to"))
                          ),
                        ])
                      : _vm._e(),
                    _vm._v(" " + _vm._s(_vm.locationName) + "        \n      "),
                  ])
                : _vm._e(),
              _vm.moderation &&
              !["telegram", "instagram", "whatsapp", "bluesky"].includes(
                _vm.page.network
              )
                ? _c(
                    "p",
                    { staticClass: "date" },
                    [
                      _c(
                        "Tooltip",
                        {
                          attrs: {
                            text: _vm.dateFormat(_vm.post.date),
                            position: "top",
                          },
                        },
                        [
                          _c("span", [
                            _vm._v(_vm._s(_vm.dateFromNow(_vm.post.date))),
                          ]),
                          _vm._v("\n           \n        "),
                        ]
                      ),
                    ],
                    1
                  )
                : !["telegram", "instagram", "whatsapp", "bluesky"].includes(
                    _vm.page.network
                  )
                ? _c(
                    "p",
                    {
                      staticClass: "date",
                      on: {
                        click: function ($event) {
                          $event.preventDefault()
                          _vm.live &&
                          !_vm.activeEdit.scheduling &&
                          _vm.isUserPremiumActive
                            ? _vm.showEditPost("scheduling")
                            : null
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n        " + _vm._s(_vm.postDate) + "\n        "
                      ),
                      _vm.live && !_vm.doScreenshot
                        ? _c(
                            "span",
                            { staticClass: "btn-edit" },
                            [
                              _c(
                                "Tooltip",
                                {
                                  attrs: {
                                    text: _vm.$t("dash.post.overlay.edit.date"),
                                    position: "top",
                                  },
                                },
                                [
                                  _c("vs-button", {
                                    directives: [
                                      {
                                        name: "show",
                                        rawName: "v-show",
                                        value:
                                          _vm.live &&
                                          !_vm.activeEdit.scheduling &&
                                          _vm.isUserPremiumActive,
                                        expression:
                                          "live && !activeEdit.scheduling && isUserPremiumActive",
                                      },
                                    ],
                                    attrs: {
                                      "vs-type": "filled",
                                      icon: "edit",
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.preventDefault()
                                        return _vm.showEditPost("scheduling")
                                      },
                                    },
                                  }),
                                  _vm._v("\n              \n          "),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  )
                : _vm._e(),
              _vm.live &&
              _vm.activeEdit.scheduling &&
              !["telegram", "instagram", "whatsapp", "bluesky"].includes(
                _vm.page.network
              )
                ? _c("div", { staticClass: "live-scheduling schedule" }, [
                    _c("div", { staticClass: "schedule-wrapper" }, [
                      _c(
                        "div",
                        { staticClass: "edit-scheduling" },
                        [
                          _c("component-datepicker", {
                            staticClass: "posts-datepicker",
                            attrs: {
                              date: new Date(_vm.editValue.scheduling.date),
                              now: true,
                            },
                            on: { picked: _vm.picked },
                          }),
                          _c(
                            "div",
                            { staticClass: "posts-timepicker" },
                            [
                              _c("img", {
                                attrs: {
                                  src: require("../../assets/img/icon_time_black.svg"),
                                  alt: "time",
                                },
                              }),
                              _c("vue-timepicker", {
                                attrs: {
                                  "hour-range": _vm.rangeHour,
                                  "minute-range": _vm.rangeMinute,
                                  "auto-scroll": "",
                                  "minute-interval": _vm.minuteInterval,
                                },
                                on: { change: _vm.changeRangeSchedulingTime },
                                model: {
                                  value: _vm.editValue.scheduling.time,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.editValue.scheduling,
                                      "time",
                                      $$v
                                    )
                                  },
                                  expression: "editValue.scheduling.time",
                                },
                              }),
                            ],
                            1
                          ),
                          _c("vs-button", {
                            attrs: { "vs-type": "filled", icon: "close" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.activeEdit.scheduling = false
                              },
                            },
                          }),
                          _c("vs-button", {
                            attrs: { "vs-type": "filled", icon: "check" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.editPost("scheduling")
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ]),
                  ])
                : _vm._e(),
            ]),
          ]),
          _vm.textTruncated
            ? _c("div", { staticClass: "message-truncated" }, [
                _vm._v(
                  "\n    " +
                    _vm._s(_vm.$t("dash.post.preview.message.truncated")) +
                    "\n  "
                ),
              ])
            : _vm._e(),
          !["instagram", "pinterest", "google", "youtube", "whatsapp"].includes(
            _vm.page.network
          )
            ? _c(
                "div",
                {
                  staticClass: "title",
                  class: [
                    {
                      lorem:
                        _vm.post.title == "" &&
                        !_vm.moderation &&
                        !["image", "video"].includes(_vm.typePost),
                      live: _vm.live,
                    },
                  ],
                },
                [
                  !_vm.activeEdit.title
                    ? _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.live && !_vm.activeEdit.title
                                ? _vm.showEditPost("title")
                                : null
                            },
                          },
                        },
                        [
                          _vm.activePrefixSuffix &&
                          _vm.bot &&
                          _vm.bot.hashtagPrefix &&
                          _vm.post.title != ""
                            ? _c("span", {
                                staticClass: "hashtag-prefix",
                                domProps: {
                                  innerHTML: _vm._s(
                                    `${_vm.addHashtagsLinks(
                                      _vm.bot.hashtagPrefix
                                    )} `
                                  ),
                                },
                              })
                            : _vm._e(),
                          !_vm.disableCTA &&
                          _vm.post.page &&
                          _vm.post.page[0] &&
                          _vm.post.page[0].is_reshare
                            ? _c("span", {
                                staticClass: "title-preview",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.handleNewLine(
                                      _vm.post.page[0].reshare_message
                                    )
                                  ),
                                },
                              })
                            : _c("span", {
                                staticClass: "title-preview",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.handleNewLine(
                                      _vm.getMessageToPost(_vm.post)
                                    )
                                  ),
                                },
                              }),
                          _vm.activePrefixSuffix &&
                          _vm.bot &&
                          _vm.bot.hashtag &&
                          _vm.post.title != ""
                            ? _c("span", {
                                staticClass: "hashtag-suffix",
                                domProps: {
                                  innerHTML: _vm._s(
                                    ` ${_vm.addHashtagsLinks(_vm.bot.hashtag)}`
                                  ),
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm.live && !_vm.doScreenshot && _vm.post.title != ""
                    ? _c("div", { staticClass: "live-title" }, [
                        _c(
                          "span",
                          { staticClass: "btn-edit" },
                          [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t(
                                    "dash.post.overlay.edit.message"
                                  ),
                                  position: "top",
                                },
                              },
                              [
                                _c("vs-button", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.activeEdit.title,
                                      expression: "!activeEdit.title",
                                    },
                                  ],
                                  attrs: { "vs-type": "filled", icon: "edit" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.showEditPost("title")
                                    },
                                  },
                                }),
                                _vm._v("\n            \n        "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.activeEdit.title
                          ? _c(
                              "div",
                              { staticClass: "edit-title" },
                              [
                                _c("vs-button", {
                                  staticClass: "close",
                                  attrs: { "vs-type": "filled", icon: "close" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.activeEdit.title = false
                                    },
                                  },
                                }),
                                _c("vs-button", {
                                  staticClass: "save",
                                  attrs: { "vs-type": "filled", icon: "check" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.editPost("title")
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideEmojiPicker,
                                        expression: "hideEmojiPicker",
                                      },
                                    ],
                                    staticClass: "textarea-emoji-picker",
                                  },
                                  [
                                    _vm.page.network !== "bluesky"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "styles-text-buttons",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "emoji-trigger",
                                                class: {
                                                  triggered: _vm
                                                    .styledText()
                                                    .includes("bold"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.styleSelection(
                                                      "bold"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      viewBox: "0 0 20 20",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        fill: "#888888",
                                                        d: "M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "emoji-trigger",
                                                class: {
                                                  triggered: _vm
                                                    .styledText()
                                                    .includes("italic"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.styleSelection(
                                                      "italic"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      viewBox: "0 0 20 20",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        fill: "#888888",
                                                        d: "M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z ",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "emoji-trigger",
                                                class: {
                                                  triggered: _vm
                                                    .styledText()
                                                    .includes("underline"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.styleSelection(
                                                      "underline"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      viewBox: "0 0 20 20",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        fill: "#888888",
                                                        d: "M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z",
                                                      },
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        fill: "#888888",
                                                        d: "M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.page.network !== "bluesky"
                                      ? _c("picker", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showEmojiPicker,
                                              expression: "showEmojiPicker",
                                            },
                                          ],
                                          attrs: {
                                            data: _vm.emojiIndex,
                                            title: "Pick your emoji...",
                                            emoji: "point_up",
                                          },
                                          on: { select: _vm.addEmoji },
                                        })
                                      : _vm._e(),
                                    _vm.page.network !== "bluesky"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "emoji-trigger",
                                            class: {
                                              triggered: _vm.showEmojiPicker,
                                            },
                                            on: {
                                              click: _vm.toggleEmojiPicker,
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticStyle: {
                                                  width: "20px",
                                                  height: "20px",
                                                },
                                                attrs: { viewBox: "0 0 24 24" },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    fill: "#888888",
                                                    d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "add-mention",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowMentions(
                                              "Mention"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("@")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "add-mention add-hashtag",
                                        class: {
                                          disabled: !_vm.activeSearchHashtags,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowMentions(
                                              "Hashtag"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("#")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "add-mention ai-generate",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getAccrochesByAI()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("lightbulb_outline")]
                                        ),
                                      ]
                                    ),
                                    _c("vs-textarea", {
                                      ref: `inputTitle-${_vm.page.network_id}`,
                                      class: { input: true },
                                      attrs: {
                                        "vs-size": "large",
                                        color: "#B20564",
                                        name: "title",
                                        placeholder: _vm.$t(
                                          "dash.posts.overlay.description_placeholder"
                                        ),
                                        id: `inputTitle-${_vm.page.network_id}`,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[_vm.checkAddMention()]
                                        },
                                        keyup: function ($event) {
                                          ;[
                                            _vm.checkTruncate(),
                                            _vm.checkAddMention(),
                                            _vm.textAreaAdjust(
                                              `inputTitle-${_vm.page.network_id}`
                                            ),
                                          ]
                                        },
                                      },
                                      model: {
                                        value: _vm.editValue.title,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.editValue, "title", $$v)
                                        },
                                        expression: "editValue.title",
                                      },
                                    }),
                                    _vm.limitText()
                                      ? _c(
                                          "div",
                                          { staticClass: "vs-textarea--count" },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.sizeCurrentMessage()
                                                ) +
                                                " / " +
                                                _vm._s(_vm.limitText()) +
                                                "\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  (((_vm.image || _vm.post.video) &&
                    ["image", "video"].includes(_vm.typePost)) ||
                    (_vm.post.page &&
                      _vm.post.page[0] &&
                      (_vm.post.page[0].enclosure || _vm.post.page[0].video)) ||
                    ((!_vm.post.status || _vm.post.status == "preview") &&
                      _vm.bot &&
                      _vm.bot.mode === "image" &&
                      !["standard", "story"].includes(_vm.typePost)) ||
                    (["twitter", "telegram"].includes(_vm.page.network) &&
                      _vm.meta &&
                      _vm.meta.og &&
                      !(
                        _vm.meta.og.image ||
                        (_vm.meta.og.images && _vm.meta.og.images[0])
                      )) ||
                    (["image"].includes(_vm.typePost) &&
                      _vm.meta &&
                      _vm.meta.og &&
                      (_vm.meta.og.image ||
                        (_vm.meta.og.images && _vm.meta.og.images[0])))) &&
                  _vm.post.url &&
                  _vm.page.network != "instagram"
                    ? _c("span", [
                        _vm.live && !_vm.doScreenshot
                          ? _c(
                              "div",
                              {
                                staticClass: "link",
                                class: {
                                  visibility_off:
                                    _vm.isRemoveUrlInMessageToPost(),
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getUrlWithUtm.substr(0, 42)) +
                                      "..."
                                  ),
                                ]),
                                _c(
                                  "Tooltip",
                                  {
                                    staticClass: "visibility-link",
                                    attrs: {
                                      text: _vm.$t(
                                        `dash.posts.form.${
                                          _vm.isRemoveUrlInMessageToPost()
                                            ? "show-url"
                                            : "hide-url"
                                        }`
                                      ),
                                      position: "left",
                                    },
                                  },
                                  [
                                    _c(
                                      "i",
                                      {
                                        staticClass: "material-icons",
                                        on: {
                                          click: function ($event) {
                                            return _vm.removeUrlInMessage()
                                          },
                                        },
                                      },
                                      [
                                        _vm._v(
                                          _vm._s(
                                            _vm.isRemoveUrlInMessageToPost()
                                              ? "visibility"
                                              : "visibility_off"
                                          )
                                        ),
                                      ]
                                    ),
                                    _vm._v("\n           \n      "),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm.isRemoveUrlInMessageToPost()
                          ? _c("span")
                          : _c(
                              "a",
                              {
                                attrs: {
                                  href: _vm.getUrlWithUtm,
                                  target: "blank",
                                },
                              },
                              [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(_vm.getUrlWithUtm.substr(0, 42)) +
                                      "..."
                                  ),
                                ]),
                              ]
                            ),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.page.network == "wonderpush" &&
          _vm.post.page &&
          _vm.post.page[0] &&
          _vm.post.page[0].description
            ? _c("div", { staticClass: "description" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.handleNewLine(
                        _vm.post.page[0].description,
                        false,
                        false,
                        true
                      )
                    ),
                  },
                }),
              ])
            : ["wonderpush"].includes(_vm.page.network) && _vm.post.description
            ? _c("div", { staticClass: "description" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.handleNewLine(
                        _vm.getMessageToPostDescription(_vm.post),
                        false,
                        false,
                        true
                      )
                    ),
                  },
                }),
              ])
            : _vm._e(),
          ["telegram"].includes(_vm.page.network) && _vm.meta && _vm.meta.og
            ? _c("p", { staticClass: "description" }, [
                _vm._v(_vm._s(_vm.meta.og.description)),
              ])
            : _vm._e(),
          _vm.reshare
            ? _c(
                "div",
                { staticClass: "card" },
                [
                  _c("preview-post", {
                    attrs: {
                      page: _vm.resharePage,
                      post: _vm.reshare,
                      disableCTA: true,
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          ["instagram", "google"].includes(_vm.page.network) &&
          _vm.typePost === "standard" &&
          _vm.meta &&
          _vm.meta.og &&
          _vm.meta.og.image
            ? _c(
                "Tooltip",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.live && !_vm.doScreenshot,
                      expression: "live && !doScreenshot",
                    },
                  ],
                  staticClass: "edit-image-mod",
                  attrs: {
                    text: _vm.$t("dash.posts.form.media"),
                    position: "left",
                  },
                },
                [
                  _c("vs-button", {
                    attrs: { "vs-type": "filled", icon: "edit" },
                    on: {
                      click: function ($event) {
                        $event.preventDefault()
                        return _vm.showEditPost("image")
                      },
                    },
                  }),
                  _vm._v("\n       \n      "),
                  _c("input", {
                    ref: "modifyImage",
                    attrs: { type: "file", hidden: "" },
                  }),
                ],
                1
              )
            : _vm._e(),
          (_vm.typePost === "poll" && _vm.poll && _vm.poll.question != "") ||
          (this.post &&
            this.post.page &&
            this.post.page[0] &&
            this.post.page[0].poll &&
            this.post.page[0].poll.question)
            ? _c("div", { staticClass: "poll-container" }, [
                _vm.pollValue.question.length > 0
                  ? _c("span", { staticClass: "poll-question" }, [
                      _vm._v(_vm._s(_vm.pollValue.question)),
                    ])
                  : _vm._e(),
                _c(
                  "div",
                  { staticClass: "poll-options" },
                  _vm._l(
                    _vm.pollValue.options.filter((e) => e != ""),
                    function (opt) {
                      return _c("span", { key: opt }, [_vm._v(_vm._s(opt))])
                    }
                  ),
                  0
                ),
                _c("span", { staticClass: "poll-duration" }, [
                  _vm._v("0 vote  • Il reste " + _vm._s(_vm.pollDuration)),
                ]),
              ])
            : _vm.page.network === "linkedin" &&
              (_vm.typePost === "document" ||
                (_vm.post.page &&
                  _vm.post.page[0] &&
                  _vm.post.page[0].document_title &&
                  _vm.post.page[0].document_title !== "") ||
                (_vm.post.page &&
                  _vm.post.page[0] &&
                  _vm.post.page[0].enclosure &&
                  _vm.post.page[0].enclosure.endsWith(".pdf"))) &&
              (_vm.image ||
                (_vm.post.page &&
                  _vm.post.page[0] &&
                  _vm.post.page[0].enclosure))
            ? _c(
                "div",
                { staticClass: "pdf-viewer" },
                [
                  _vm.pdfReset
                    ? _c("pdf", {
                        attrs: {
                          src: _vm.image || _vm.post.page[0].enclosure,
                          page: _vm.pdfPage,
                        },
                        on: { numpages: (n) => (_vm.pdfPageNumber = n) },
                      })
                    : _vm._e(),
                  _c("span", { staticClass: "pdf-title" }, [
                    _c("b", [
                      _vm._v(
                        _vm._s(
                          _vm.pdfTitle ||
                            (_vm.post.page &&
                              _vm.post.page[0] &&
                              _vm.post.page[0].document_title)
                        )
                      ),
                    ]),
                    _vm._v(" . " + _vm._s(_vm.pdfPageNumber) + " pages"),
                  ]),
                  _c("span", { staticClass: "pdf-foot" }, [
                    _vm._v(
                      _vm._s(_vm.pdfPage) + " / " + _vm._s(_vm.pdfPageNumber)
                    ),
                  ]),
                  _vm.pdfPage > 1
                    ? _c(
                        "svg",
                        {
                          staticClass: "previous-page",
                          attrs: {
                            viewBox: "0 0 24 24",
                            width: "24px",
                            height: "24px",
                            x: "0",
                            y: "0",
                            preserveAspectRatio: "xMinYMin meet",
                            focusable: "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.pdfPage--
                            },
                          },
                        },
                        [
                          _c("path", {
                            staticClass: "large-icon",
                            staticStyle: {
                              fill: "currentcolor",
                              "--darkreader-inline-fill": "currentcolor",
                            },
                            attrs: {
                              d: "M10,12l6,8.94L14.45,22,8.26,12.85a1.5,1.5,0,0,1,0-1.69L14.45,2,16,3.06Z",
                              "data-darkreader-inline-fill": "",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                  _vm.pdfPage < _vm.pdfPageNumber
                    ? _c(
                        "svg",
                        {
                          staticClass: "next-page",
                          attrs: {
                            viewBox: "0 0 24 24",
                            width: "24px",
                            height: "24px",
                            x: "0",
                            y: "0",
                            preserveAspectRatio: "xMinYMin meet",
                            focusable: "false",
                          },
                          on: {
                            click: function ($event) {
                              _vm.pdfPage++
                            },
                          },
                        },
                        [
                          _c("path", {
                            staticClass: "large-icon",
                            staticStyle: {
                              fill: "currentcolor",
                              "--darkreader-inline-fill": "currentcolor",
                            },
                            attrs: {
                              d: "M14,12L8,3.06,9.55,2l6.19,9.15a1.5,1.5,0,0,1,0,1.69L9.55,22,8,20.94Z",
                              "data-darkreader-inline-fill": "",
                            },
                          }),
                        ]
                      )
                    : _vm._e(),
                ],
                1
              )
            : !_vm.disableCTA &&
              _vm.post.page &&
              _vm.post.page[0] &&
              _vm.post.page[0].is_reshare
            ? _c(
                "div",
                { staticClass: "card" },
                [
                  _c("preview-post", {
                    attrs: { page: _vm.page, post: _vm.post, disableCTA: true },
                  }),
                ],
                1
              )
            : _vm.carouselData &&
              _vm.carouselData.length > 1 &&
              ["instagram", "threads"].includes(_vm.page.network)
            ? _c(
                "div",
                { staticClass: "post-image carrousel" },
                [
                  _c(
                    "carousel",
                    {
                      attrs: {
                        perPage: _vm.page.network == "threads" ? 2 : 1,
                        scrollPerPage:
                          _vm.page.network == "threads" ? false : true,
                        paginationEnabled:
                          _vm.page.network == "threads" ? false : true,
                        adjustableHeight: true,
                        centerMode: true,
                      },
                    },
                    _vm._l(
                      _vm.carouselData.filter((e) => e.file),
                      function (media) {
                        return _c("slide", { key: media.id }, [
                          _c(
                            "div",
                            [
                              _vm.compressedImages &&
                              !_vm.compressedImages.includes(media.id)
                                ? _c(
                                    "Tooltip",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value: _vm.live,
                                          expression: "live",
                                        },
                                      ],
                                      staticClass:
                                        "compress-image-warning insta",
                                      staticStyle: {
                                        position: "relative !important",
                                      },
                                      attrs: {
                                        text: _vm.$t(
                                          "dash.post.compressed.image.warning.in_progress"
                                        ),
                                        position: "left",
                                      },
                                    },
                                    [
                                      _c("img", {
                                        attrs: {
                                          src: require("../../assets/img/compress.svg"),
                                          alt: "compress",
                                        },
                                      }),
                                      _vm._v("\n             \n        "),
                                    ]
                                  )
                                : _vm._e(),
                              _c("img", {
                                staticClass: "carrousel-image",
                                style: `aspect-ratio: ${
                                  _vm.page.network === "instagram"
                                    ? media.ratio === 0
                                      ? _vm.firstImageAspectRatio
                                      : media.ratio
                                    : "auto"
                                };`,
                                attrs: { src: media.url },
                              }),
                            ],
                            1
                          ),
                        ])
                      }
                    ),
                    1
                  ),
                ],
                1
              )
            : _vm.carouselData &&
              _vm.carouselData.length > 1 &&
              ["twitter", "bluesky"].includes(_vm.page.network)
            ? _c("div", { staticClass: "post-image carrousel" }, [
                _c(
                  "div",
                  {
                    staticClass: "carrousel-twitter",
                    style: `flex-direction: ${
                      _vm.carouselPreview.length === 3
                        ? "column-reverse"
                        : "row"
                    }; flex-wrap: ${
                      _vm.carouselPreview.length === 3 ? "wrap-reverse" : "wrap"
                    };`,
                  },
                  _vm._l(_vm.carouselPreview, function (media) {
                    return _c(
                      "span",
                      {
                        key: media.id,
                        staticClass: "carrousel-image-split-container",
                        style: `width: ${
                          _vm.carouselPreview.length > 2 ? "50%" : "100%"
                        }; height: ${
                          _vm.carouselPreview.length > 3 ? "50%" : "100%"
                        };`,
                        on: {
                          dragstart: _vm.dragOrderCarouselStart,
                          dragover: (e) => _vm.dragOrderCarousel(e, "twitter"),
                          drop: _vm.dragOrderCarouselStop,
                          dragleave: _vm.dragCarouselLeave,
                        },
                      },
                      [
                        _vm.compressedImages &&
                        !_vm.compressedImages.includes(media.id)
                          ? _c(
                              "Tooltip",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.live,
                                    expression: "live",
                                  },
                                ],
                                staticClass: "compress-image-warning",
                                attrs: {
                                  text: _vm.$t(
                                    "dash.post.compressed.image.warning.in_progress"
                                  ),
                                  position: "left",
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/compress.svg"),
                                    alt: "compress",
                                  },
                                }),
                                _vm._v("\n             \n        "),
                              ]
                            )
                          : _vm._e(),
                        _c("img", {
                          staticClass: "carrousel-image-split",
                          attrs: { src: media.url, id: media.id },
                        }),
                      ],
                      1
                    )
                  }),
                  0
                ),
              ])
            : _vm.carouselData &&
              _vm.carouselData.length > 1 &&
              _vm.page.network === "linkedin"
            ? _c("div", { staticClass: "post-image carrousel" }, [
                _c(
                  "div",
                  {
                    staticClass: "carrousel-linkedin",
                    style: `flex-direction: ${
                      _vm.carouselPreview.length > 2 ? "row-reverse" : "row"
                    }; 
        flex-wrap: ${
          _vm.carouselPreview.length > 2 ? "wrap-reverse" : "wrap"
        };`,
                  },
                  [
                    _vm._l(_vm.carouselPreview, function (media, idx) {
                      return _c(
                        "span",
                        {
                          key: media.id,
                          staticClass: "carrousel-image-split-container",
                          style: `height: ${
                            _vm.carouselPreview.length > 4 && idx > 2
                              ? "60%"
                              : _vm.carouselPreview.length > 2
                              ? idx === _vm.carouselPreview.length - 1
                                ? "60%"
                                : "40%"
                              : "auto"
                          }; 
            flex-basis: ${
              _vm.carouselPreview.length > 4 && idx > 2
                ? "50%"
                : _vm.carouselPreview.length > 3
                ? idx > 2
                  ? "100%"
                  : "33%"
                : "50%"
            };`,
                          on: {
                            dragstart: _vm.dragOrderCarouselStart,
                            dragover: (e) =>
                              _vm.dragOrderCarousel(e, "linkedin"),
                            drop: _vm.dragOrderCarouselStop,
                            dragleave: _vm.dragCarouselLeave,
                          },
                        },
                        [
                          _vm.compressedImages &&
                          !_vm.compressedImages.includes(media.id)
                            ? _c(
                                "Tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.live,
                                      expression: "live",
                                    },
                                  ],
                                  staticClass: "compress-image-warning",
                                  attrs: {
                                    text: _vm.$t(
                                      "dash.post.compressed.image.warning.in_progress"
                                    ),
                                    position: "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/img/compress.svg"),
                                      alt: "compress",
                                    },
                                  }),
                                  _vm._v("\n             \n        "),
                                ]
                              )
                            : _vm._e(),
                          _c("img", {
                            staticClass: "carrousel-image-split",
                            attrs: { src: media.url, id: media.id },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm.carouselData.filter((e) => e.file).length > 5
                      ? _c("div", { staticClass: "more-image" }, [
                          _vm._v(
                            "+" +
                              _vm._s(
                                _vm.carouselData.filter((e) => e.file).length -
                                  5
                              )
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : _vm.carouselData &&
              _vm.carouselData.length > 1 &&
              _vm.page.network === "facebook"
            ? _c("div", { staticClass: "post-image carrousel" }, [
                _c(
                  "div",
                  {
                    staticClass: "carrousel-facebook",
                    style: `aspect-ratio: ${
                      _vm.carouselPreview.length > 3
                        ? 1
                        : _vm.carouselPreview.length === 3
                        ? 0.9
                        : _vm.carouselPreview.length
                    };
        flex-direction: ${
          _vm.carouselPreview.length === 3 ? "row-reverse" : "row"
        };
        flex-wrap: ${
          _vm.carouselPreview.length === 3 ? "wrap-reverse" : "wrap"
        };`,
                  },
                  [
                    _vm._l(_vm.carouselPreview, function (media, idx) {
                      return _c(
                        "span",
                        {
                          key: media.id,
                          staticClass: "carrousel-image-split-container",
                          style: `width: ${
                            _vm.carouselPreview.length === 3 && idx === 2
                              ? "100%"
                              : "auto"
                          }; height: ${
                            _vm.carouselPreview.length > 2 ? "50%" : "auto"
                          }`,
                          on: {
                            dragstart: _vm.dragOrderCarouselStart,
                            dragover: (e) =>
                              _vm.dragOrderCarousel(e, "facebook"),
                            drop: _vm.dragOrderCarouselStop,
                            dragleave: _vm.dragCarouselLeave,
                          },
                        },
                        [
                          _vm.compressedImages &&
                          !_vm.compressedImages.includes(media.id)
                            ? _c(
                                "Tooltip",
                                {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: _vm.live,
                                      expression: "live",
                                    },
                                  ],
                                  staticClass: "compress-image-warning",
                                  attrs: {
                                    text: _vm.$t(
                                      "dash.post.compressed.image.warning.in_progress"
                                    ),
                                    position: "left",
                                  },
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/img/compress.svg"),
                                      alt: "compress",
                                    },
                                  }),
                                  _vm._v("\n             \n        "),
                                ]
                              )
                            : _vm._e(),
                          _c("img", {
                            staticClass: "carrousel-image-split",
                            attrs: { src: media.url, id: media.id },
                          }),
                        ],
                        1
                      )
                    }),
                    _vm.carouselData.filter((e) => e.file).length > 4
                      ? _c("div", { staticClass: "more-image" }, [
                          _vm._v(
                            "+" +
                              _vm._s(
                                _vm.carouselData.filter((e) => e.file).length -
                                  3
                              )
                          ),
                        ])
                      : _vm._e(),
                  ],
                  2
                ),
              ])
            : ((_vm.multipleMedias && _vm.multipleMedias.length > 1) ||
                (_vm.post.page &&
                  _vm.post.page.length &&
                  _vm.post.page[0].multipleMedias &&
                  _vm.post.page[0].multipleMedias.length > 1)) &&
              ["instagram", "threads"].includes(_vm.page.network)
            ? _c(
                "div",
                { staticClass: "post-image video carrousel" },
                [
                  _c(
                    "carousel",
                    {
                      attrs: {
                        perPage: _vm.page.network == "threads" ? 2 : 1,
                        scrollPerPage:
                          _vm.page.network == "threads" ? false : true,
                        paginationEnabled:
                          _vm.page.network == "threads" ? false : true,
                        adjustableHeight: true,
                        centerMode: true,
                      },
                    },
                    _vm._l(
                      (
                        _vm.multipleMedias || _vm.post.page[0].multipleMedias
                      ).filter((e) => e.url),
                      function (media) {
                        return _c("slide", { key: media.id }, [
                          _c("div", [
                            media.type.includes("image")
                              ? _c("img", {
                                  staticClass: "carrousel-image",
                                  style: `aspect-ratio: ${
                                    _vm.page.network === "instagram"
                                      ? media.ratio
                                      : "auto"
                                  };`,
                                  attrs: { src: media.url },
                                })
                              : media.type.includes("video")
                              ? _c("video", {
                                  staticClass: "ratio",
                                  attrs: {
                                    id: _vm.live ? `video-${_vm.page.id}` : "",
                                    src: media.url,
                                    controls: "",
                                  },
                                  on: { loadedmetadata: _vm.videoRatio },
                                })
                              : _vm._e(),
                          ]),
                        ])
                      }
                    ),
                    1
                  ),
                ],
                1
              )
            : _vm.page.network === "instagram" && _vm.typePost === "story"
            ? _c("story", {
                class: !_vm.live && "storification-preview-size",
                attrs: {
                  story: !_vm.storificationObject
                    ? {
                        image: _vm.imageStory,
                        video: _vm.videoStory,
                      }
                    : undefined,
                  storification: _vm.storificationObject
                    ? {
                        image:
                          (_vm.carouselData &&
                            _vm.carouselData[0] &&
                            _vm.carouselData[0].url) ||
                          _vm.post.enclosure ||
                          _vm.image ||
                          (_vm.meta && _vm.meta.og && _vm.meta.og.image) ||
                          (_vm.meta &&
                            _vm.meta.og &&
                            _vm.meta.og.images &&
                            _vm.meta.images[0] &&
                            _vm.meta.images[0].url) ||
                          (_vm.meta &&
                            _vm.meta.images &&
                            _vm.meta.images[0] &&
                            _vm.meta.images[0].url),
                        username: _vm.storificationObject.username,
                        isCarousel:
                          _vm.storificationObject.isCarousel ||
                          (_vm.carouselData && _vm.carouselData.length > 1),
                      }
                    : undefined,
                  backgroundColor:
                    _vm.$store.getters.storificationBackgroundColor,
                  link: {
                    url: _vm.post.url,
                    initialDatas: _vm.$store.getters.storificationLink,
                    isActive: _vm.$store.getters.storificationLinkIsActive,
                    text: _vm.$store.getters.storificationLinkText,
                  },
                  texts: _vm.$store.getters.storificationTexts,
                  layers: _vm.$store.getters.storificationLayers,
                  gifs: _vm.$store.getters.storificationGifs,
                  music: _vm.$store.getters.storificationMusic,
                  location: _vm.$store.getters.storificationLocation,
                  product: _vm.$store.getters.storificationProduct,
                  poll: _vm.$store.getters.storificationPoll,
                  slider: _vm.$store.getters.storificationSlider,
                  mentions: _vm.$store.getters.storificationMentions,
                  hashtags: _vm.$store.getters.storificationHashtags,
                  question: _vm.$store.getters.storificationQuestion,
                  template: {
                    config: _vm.$store.getters.storificationTemplate,
                    custom: _vm.currentBot
                      ? _vm.currentBot.storyTemplate
                      : null,
                  },
                  preview:
                    _vm.live && _vm.index === 0
                      ? null
                      : {
                          Link: _vm.$store.getters.storificationLink,
                          Text: _vm.$store.getters.storificationTexts,
                          Layer: _vm.$store.getters.storificationLayers,
                          Gif: _vm.$store.getters.storificationGifs,
                          Poll: _vm.$store.getters.storificationPoll,
                          Slider: _vm.$store.getters.storificationSlider,
                          Mention: _vm.$store.getters.storificationMentions,
                          Hashtag: _vm.$store.getters.storificationHashtags,
                          Location: _vm.$store.getters.storificationLocation,
                          Product: _vm.$store.getters.storificationProduct,
                          Question: _vm.$store.getters.storificationQuestion,
                        },
                  informations: {
                    mentions: _vm.currentBot,
                    acceptReplaceHashtag: _vm.activeHashtagsAutoAdd,
                    validMentions: _vm.validMentions,
                    validHashtags: _vm.validHashtags,
                    acceptPrefix: _vm.activePrefixSuffix,
                    pageInfo: _vm.page,
                    highlight: _vm.highlightStoryEnable,
                  },
                },
              })
            : _vm.post.video &&
              typeof _vm.post.video === "string" &&
              _vm.post.video.includes("http")
            ? _c("div", { staticClass: "post-image video" }, [
                ["linkedin", "facebook", "instagram"].includes(
                  _vm.page.network
                ) &&
                (_vm.image ||
                  (_vm.post.page &&
                    _vm.post.page[0] &&
                    _vm.post.page[0].enclosure))
                  ? _c("video", {
                      class: `ratio${_vm.videoReel ? "-reel" : ""}`,
                      attrs: {
                        id: _vm.live ? `video-${_vm.page.id}` : "",
                        src: _vm.post.video,
                        poster: _vm.image || _vm.post.page[0].enclosure,
                        controls: "",
                      },
                      on: { loadedmetadata: _vm.videoRatio },
                    })
                  : _c("video", {
                      class: `ratio${_vm.videoReel ? "-reel" : ""}`,
                      attrs: {
                        id: _vm.live ? `video-${_vm.page.id}` : "",
                        src: _vm.post.video,
                        controls: "",
                      },
                      on: { loadedmetadata: _vm.videoRatio },
                    }),
              ])
            : _vm.post.videos &&
              _vm.post.videos[_vm.page.network] &&
              _vm.post.videos[_vm.page.network].includes("http")
            ? _c("div", { staticClass: "post-image video" }, [
                ["linkedin", "facebook", "instagram"].includes(
                  _vm.page.network
                ) &&
                (_vm.image ||
                  (_vm.post.page &&
                    _vm.post.page[0] &&
                    _vm.post.page[0].enclosure))
                  ? _c("video", {
                      class: `ratio${_vm.videoReel ? "-reel" : ""}`,
                      attrs: {
                        id: _vm.live ? `video-${_vm.page.id}` : "",
                        src: _vm.post.videos[_vm.page.network],
                        poster: _vm.image || _vm.post.page[0].enclosure,
                        controls: "",
                      },
                      on: { loadedmetadata: _vm.videoRatio },
                    })
                  : _c("video", {
                      class: `ratio${_vm.videoReel ? "-reel" : ""}`,
                      attrs: {
                        id: _vm.live ? `video-${_vm.page.id}` : "",
                        src: _vm.post.videos[_vm.page.network],
                        controls: "",
                      },
                      on: { loadedmetadata: _vm.videoRatio },
                    }),
              ])
            : _vm.post.page && _vm.post.page[0] && _vm.post.page[0].video
            ? _c("div", { staticClass: "post-image video" }, [
                ["linkedin", "facebook", "instagram"].includes(
                  _vm.page.network
                ) &&
                (_vm.image ||
                  (_vm.post.page &&
                    _vm.post.page[0] &&
                    _vm.post.page[0].enclosure))
                  ? _c("video", {
                      class: `ratio${_vm.videoReel ? "-reel" : ""}`,
                      attrs: {
                        id: _vm.live ? `video-${_vm.page.id}` : "",
                        src: _vm.post.page[0].video,
                        poster: _vm.image || _vm.post.page[0].enclosure,
                        controls: "",
                      },
                      on: { loadedmetadata: _vm.videoRatio },
                    })
                  : _c("video", {
                      class: `ratio${_vm.videoReel ? "-reel" : ""}`,
                      attrs: {
                        id: _vm.live ? `video-${_vm.page.id}` : "",
                        src: _vm.post.page[0].video,
                        controls: "",
                      },
                      on: { loadedmetadata: _vm.videoRatio },
                    }),
              ])
            : (_vm.editValue.imageBase64 ||
                (_vm.editPostValue &&
                  _vm.editPostValue.filter((e) => e.page === _vm.page.id)
                    .length > 0 &&
                  _vm.editPostValue.filter((e) => e.page === _vm.page.id)[0]
                    .imageBase64)) &&
              (_vm.page.network === "instagram" ||
                _vm.page.network === "google")
            ? _c("div", { staticClass: "post-image" }, [
                _c("img", {
                  ref: "imageRef",
                  class: `post-image-img`,
                  attrs: {
                    src:
                      _vm.editValue.imageBase64 ||
                      (_vm.editPostValue &&
                        _vm.editPostValue.filter(
                          (e) => e.page === _vm.page.id
                        )[0].imageBase64),
                  },
                  on: { load: _vm.limitImage, error: _vm.replaceByDefault },
                }),
              ])
            : _vm.image &&
              (_vm.typePost === "image" ||
                _vm.page.network === "instagram" ||
                _vm.page.network === "google")
            ? _c(
                "div",
                { staticClass: "post-image" },
                [
                  _vm.compressedImages &&
                  _vm.compressedImages.length === 0 &&
                  _vm.image
                    ? _c(
                        "Tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.live,
                              expression: "live",
                            },
                          ],
                          staticClass: "compress-image-warning insta",
                          attrs: {
                            text: _vm.$t(
                              "dash.post.compressed.image.warning.in_progress"
                            ),
                            position: "left",
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/compress.svg"),
                              alt: "compress",
                            },
                          }),
                          _vm._v("\n         \n    "),
                        ]
                      )
                    : _vm._e(),
                  _c("img", {
                    ref: "imageRef",
                    class: `post-image-img`,
                    attrs: { src: _vm.image },
                    on: { load: _vm.limitImage, error: _vm.replaceByDefault },
                  }),
                ],
                1
              )
            : _vm.page.network === "linkedin" &&
              _vm.post.enclosure &&
              _vm.bot &&
              _vm.bot.mode === "image" &&
              ((!_vm.post.status && !_vm.typePost) ||
                _vm.post.status == "preview")
            ? _c(
                "div",
                { staticClass: "post-image" },
                [
                  _vm.compressedImages &&
                  _vm.compressedImages.length === 0 &&
                  _vm.post.enclosure
                    ? _c(
                        "Tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.live,
                              expression: "live",
                            },
                          ],
                          staticClass: "compress-image-warning insta",
                          attrs: {
                            text: _vm.$t(
                              "dash.post.compressed.image.warning.in_progress"
                            ),
                            position: "left",
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/compress.svg"),
                              alt: "compress",
                            },
                          }),
                          _vm._v("\n         \n    "),
                        ]
                      )
                    : _vm._e(),
                  _c("img", {
                    ref: "imageRef",
                    attrs: { src: _vm.post.enclosure },
                    on: { load: _vm.limitImage },
                  }),
                ],
                1
              )
            : _vm.post.page &&
              _vm.post.page[0] &&
              _vm.post.page[0].enclosure &&
              !_vm.post.meta
            ? _c(
                "div",
                { staticClass: "post-image" },
                [
                  _vm.compressedImages &&
                  _vm.compressedImages.length === 0 &&
                  _vm.post.page[0].enclosure
                    ? _c(
                        "Tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.live,
                              expression: "live",
                            },
                          ],
                          staticClass: "compress-image-warning insta",
                          attrs: {
                            text: _vm.$t(
                              "dash.post.compressed.image.warning.in_progress"
                            ),
                            position: "left",
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/compress.svg"),
                              alt: "compress",
                            },
                          }),
                          _vm._v("\n         \n    "),
                        ]
                      )
                    : _vm._e(),
                  _c("img", {
                    ref: "imageRef",
                    attrs: { src: _vm.post.page[0].enclosure },
                    on: { load: _vm.limitImage, error: _vm.replaceByDefault },
                  }),
                ],
                1
              )
            : _vm.post.enclosure && _vm.typePost === "image"
            ? _c(
                "div",
                { staticClass: "post-image" },
                [
                  _vm.compressedImages &&
                  _vm.compressedImages.length === 0 &&
                  _vm.post.enclosure
                    ? _c(
                        "Tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.live,
                              expression: "live",
                            },
                          ],
                          staticClass: "compress-image-warning insta",
                          attrs: {
                            text: _vm.$t(
                              "dash.post.compressed.image.warning.in_progress"
                            ),
                            position: "left",
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/compress.svg"),
                              alt: "compress",
                            },
                          }),
                          _vm._v("\n         \n    "),
                        ]
                      )
                    : _vm._e(),
                  _c("img", {
                    ref: "imageRef",
                    attrs: { src: _vm.post.enclosure },
                    on: { load: _vm.limitImage, error: _vm.replaceByDefault },
                  }),
                ],
                1
              )
            : ["pinterest", "instagram", "wonderpush"].includes(
                _vm.page.network
              ) ||
              _vm.typePost === "image" ||
              (((!_vm.post.status && !_vm.typePost) ||
                _vm.post.status == "preview") &&
                _vm.bot &&
                _vm.bot.mode === "image")
            ? _c(
                "div",
                { staticClass: "post-image" },
                [
                  _vm.needCompress.length
                    ? _c(
                        "Tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.live,
                              expression: "live",
                            },
                          ],
                          staticClass: "compress-image-warning insta",
                          attrs: {
                            ":text": _vm.$t(
                              "dash.post.compressed.image.warning"
                            ),
                            position: "left",
                          },
                        },
                        [
                          _c("img", {
                            attrs: {
                              src: require("../../assets/img/compress.svg"),
                              alt: "compress",
                            },
                          }),
                          _vm._v("\n         \n    "),
                        ]
                      )
                    : _vm._e(),
                  _vm.meta &&
                  _vm.meta.og &&
                  (_vm.meta.og.image ||
                    (_vm.meta.og.images && _vm.meta.og.images.length))
                    ? _c("img", {
                        ref: "imageRef",
                        class: `post-image-img`,
                        attrs: {
                          src: _vm.meta.og.image || _vm.meta.og.images[0].url,
                        },
                        on: {
                          load: _vm.limitImage,
                          error: _vm.replaceByDefault,
                        },
                      })
                    : ["linkedin", "facebook", "instagram"].includes(
                        _vm.page.network
                      ) &&
                      _vm.meta &&
                      _vm.meta.images &&
                      _vm.meta.images[0] &&
                      _vm.meta.images[0].url
                    ? _c("img", {
                        ref: "imageRef",
                        attrs: { src: _vm.meta.images[0].url },
                        on: {
                          load: _vm.limitImage,
                          error: _vm.replaceByDefault,
                        },
                      })
                    : _vm._e(),
                ],
                1
              )
            : ["oneSignal", "wonderpush", "batch"].includes(_vm.page.network)
            ? _c("div", { staticClass: "link" }, [
                _vm.post.url ? _c("br") : _vm._e(),
                _vm.post.url
                  ? _c(
                      "a",
                      { attrs: { href: _vm.post.url, target: "_blank" } },
                      [_vm._v(_vm._s(_vm.post.url))]
                    )
                  : _vm._e(),
              ])
            : ["twitter", "telegram"].includes(_vm.page.network) &&
              _vm.meta &&
              _vm.meta.og &&
              !(
                _vm.meta.og.image ||
                (_vm.meta.og.images && _vm.meta.og.images[0])
              )
            ? _c("div", { staticClass: "link" })
            : _vm.typePost !== "video" &&
              !_vm.showLoader &&
              ((_vm.page.network === "linkedin" && _vm.post.enclosure) ||
                (_vm.meta &&
                  _vm.meta.og &&
                  (_vm.meta.og.image ||
                    (_vm.meta.og.images && _vm.meta.og.images[0]) ||
                    (_vm.meta.images && _vm.meta.images[0]))))
            ? _c(
                "div",
                { staticClass: "card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-link-thumbnail",
                      on: {
                        click: function ($event) {
                          return _vm.goToLink(
                            _vm.live ? null : _vm.getUrlWithUtm
                          )
                        },
                      },
                    },
                    [
                      _vm.page.network === "telegram" && _vm.meta && _vm.meta.og
                        ? _c("p", { staticClass: "card-sitename" }, [
                            _vm._v(_vm._s(_vm.meta.og.site_name)),
                          ])
                        : _vm._e(),
                      _c("div", { staticClass: "image-wrapper" }, [
                        ["facebook", "whatsapp"].includes(_vm.page.network) &&
                        _vm.post &&
                        _vm.post.page &&
                        _vm.post.page[0] &&
                        _vm.post.page[0].snippetInbox
                          ? _c("img", {
                              staticClass: "card-img-top",
                              style:
                                _vm.page.network === "facebook" &&
                                "aspect-ratio: 1.91; object-fit: cover;",
                              attrs: {
                                src: _vm.post.page[0].snippetInbox.enclosure,
                              },
                            })
                          : ["linkedin", "facebook", "whatsapp"].includes(
                              _vm.page.network
                            ) && _vm.injectedSnippet
                          ? _c("img", {
                              staticClass: "card-img-top",
                              style:
                                _vm.page.network === "facebook" &&
                                "aspect-ratio: 1.91; object-fit: cover;",
                              attrs: {
                                src: _vm.getUrlObjectSnippet(
                                  _vm.injectedSnippet
                                ),
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.live && !_vm.activeEdit.snippet
                                    ? _vm.showEditPost("snippet")
                                    : null
                                },
                              },
                            })
                          : ["linkedin", "facebook", "whatsapp"].includes(
                              _vm.page.network
                            ) &&
                            _vm.post.page &&
                            _vm.post.page[0] &&
                            _vm.post.page[0].snippet
                          ? _c("img", {
                              staticClass: "card-img-top",
                              style:
                                _vm.page.network === "facebook" &&
                                "aspect-ratio: 1.91; object-fit: cover;",
                              attrs: {
                                src:
                                  _vm.post.enclosure ||
                                  _vm.post.page[0].snippet,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.live && !_vm.activeEdit.snippet
                                    ? _vm.showEditPost("snippet")
                                    : null
                                },
                              },
                            })
                          : _vm.meta &&
                            _vm.meta.og &&
                            (_vm.meta.og.image ||
                              (_vm.meta.og.images && _vm.meta.og.images[0]))
                          ? _c("img", {
                              staticClass: "card-img-top",
                              attrs: {
                                src:
                                  _vm.meta.og.image ||
                                  _vm.meta.og.images[0].url,
                                alt: _vm.meta.og.title,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  ;[
                                    "linkedin",
                                    "facebook",
                                    "whatsapp",
                                  ].includes(_vm.page.network) &&
                                  _vm.live &&
                                  !_vm.activeEdit.snippet
                                    ? _vm.showEditPost("snippet")
                                    : null
                                },
                              },
                            })
                          : ["linkedin", "facebook", "whatsapp"].includes(
                              _vm.page.network
                            ) &&
                            _vm.meta &&
                            _vm.meta.images &&
                            _vm.meta.images[0] &&
                            _vm.meta.images[0].url
                          ? _c("img", {
                              attrs: { src: _vm.meta.images[0].url },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.live && !_vm.activeEdit.snippet
                                    ? _vm.showEditPost("snippet")
                                    : null
                                },
                              },
                            })
                          : ["linkedin", "facebook", "whatsapp"].includes(
                              _vm.page.network
                            ) && _vm.post.enclosure
                          ? _c("img", {
                              staticClass: "card-img-top",
                              style:
                                _vm.page.network === "facebook" &&
                                "aspect-ratio: 1.91; object-fit: cover;",
                              attrs: {
                                src:
                                  _vm.post.enclosure ||
                                  _vm.post.page[0].snippet,
                              },
                              on: {
                                click: function ($event) {
                                  $event.preventDefault()
                                  _vm.live && !_vm.activeEdit.snippet
                                    ? _vm.showEditPost("snippet")
                                    : null
                                },
                              },
                            })
                          : _vm._e(),
                      ]),
                      !["google"].includes(_vm.page.network)
                        ? _c(
                            "div",
                            { staticClass: "card-block" },
                            [
                              ["facebook", "whatsapp"].includes(
                                _vm.page.network
                              ) &&
                              _vm.post &&
                              _vm.post.page &&
                              _vm.post.page[0] &&
                              _vm.post.page[0].snippetInbox
                                ? _c("h4", { staticClass: "card-title" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.post.page[0].snippetInbox.title
                                      )
                                    ),
                                  ])
                                : ["linkedin", "facebook", "whatsapp"].includes(
                                    _vm.page.network
                                  ) &&
                                  _vm.post &&
                                  _vm.post.page &&
                                  _vm.post.page[0] &&
                                  _vm.post.page[0].snippet_title
                                ? _c(
                                    "h4",
                                    {
                                      staticClass: "card-title",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.live &&
                                          !_vm.activeEdit.snippet_title
                                            ? _vm.showEditPost("snippet_title")
                                            : null
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.post.page[0].snippet_title)
                                      ),
                                    ]
                                  )
                                : _vm.activeEdit.snippet_title
                                ? _c(
                                    "div",
                                    { staticClass: "edit-snippet-input" },
                                    [
                                      _c("textarea", {
                                        ref: "snippetTitle",
                                        staticClass: "card-title",
                                        domProps: {
                                          value:
                                            _vm.snippetTitle ||
                                            (_vm.meta
                                              ? _vm.meta.meta.title
                                              : "No data"),
                                        },
                                        on: {
                                          input: (e) => {
                                            e.target.style.height = "auto"
                                            e.target.style.height =
                                              e.target.scrollHeight +
                                              (e.target.offsetHeight -
                                                e.target.clientHeight) +
                                              "px"
                                          },
                                        },
                                      }),
                                      _c("vs-button", {
                                        staticClass: "close",
                                        attrs: {
                                          "vs-type": "filled",
                                          icon: "close",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.activeEdit.snippet_title = false
                                            _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                      _c("vs-button", {
                                        attrs: {
                                          "vs-type": "filled",
                                          icon: "check",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.validateSnippetTitle.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "h4",
                                    {
                                      staticClass: "card-title",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          ;[
                                            "linkedin",
                                            "facebook",
                                            "whatsapp",
                                          ].includes(_vm.page.network) &&
                                          _vm.live &&
                                          !_vm.activeEdit.snippet_title
                                            ? _vm.showEditPost("snippet_title")
                                            : null
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.injectedSnippetTitle ||
                                            _vm.snippetTitle ||
                                            (_vm.meta
                                              ? _vm.removeHtml(
                                                  _vm.meta.og.title ||
                                                    [
                                                      "linkedin",
                                                      "facebook",
                                                    ].includes(_vm.page.network)
                                                    ? _vm.meta.meta.title
                                                    : null
                                                )
                                              : _vm
                                                  .getHostName(_vm.post.url)
                                                  .replace("www.", "")
                                                  .toUpperCase())
                                        )
                                      ),
                                    ]
                                  ),
                              ["linkedin", "facebook", "whatsapp"].includes(
                                _vm.page.network
                              ) && _vm.live
                                ? _c(
                                    "Tooltip",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.live &&
                                            !_vm.doScreenshot &&
                                            !_vm.activeEdit.snippet_title,
                                          expression:
                                            "live && !doScreenshot && !activeEdit.snippet_title",
                                        },
                                      ],
                                      staticClass: "edit-snippet-title",
                                      attrs: {
                                        text: _vm.$t(
                                          "dash.post.overlay.edit.snippet.title"
                                        ),
                                        position: "left",
                                      },
                                    },
                                    [
                                      _c("vs-button", {
                                        attrs: {
                                          "vs-type": "filled",
                                          icon: "edit",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.showEditPost(
                                              "snippet_title"
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v("\n           \n        "),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("p", { staticClass: "card-text" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.meta
                                      ? _vm.removeHtml(
                                          _vm.meta.og.description ||
                                            [
                                              "linkedin",
                                              "facebook",
                                              "whatsapp",
                                            ].includes(_vm.page.network)
                                            ? _vm.meta.og.description ||
                                                _vm.meta.meta.description
                                            : null
                                        )
                                      : null
                                  )
                                ),
                              ]),
                              !["telegram"].includes(_vm.page.network)
                                ? _c("p", { staticClass: "card-sitename" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.meta &&
                                          _vm.page.network !== "bluesky"
                                          ? _vm.meta.og.site_name
                                          : _vm.getHostName(_vm.post.url)
                                      )
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  ["linkedin", "facebook", "whatsapp"].includes(
                    _vm.page.network
                  ) && _vm.live
                    ? _c(
                        "Tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.live &&
                                !_vm.doScreenshot &&
                                !_vm.activeEdit.snippet,
                              expression:
                                "live && !doScreenshot && !activeEdit.snippet",
                            },
                          ],
                          staticClass: "edit-snippet",
                          attrs: {
                            text: _vm.$t("dash.post.overlay.edit.snippet"),
                            position: "left",
                          },
                        },
                        [
                          _c("vs-button", {
                            attrs: { "vs-type": "filled", icon: "edit" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.showEditPost("snippet")
                              },
                            },
                          }),
                          _vm._v("\n       \n    "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.activeEdit.snippet
                    ? _c("div", { staticClass: "linkedin-snippet" }, [
                        ["linkedin", "facebook", "whatsapp"].includes(
                          _vm.page.network
                        ) && _vm.live
                          ? _c(
                              "span",
                              {
                                staticClass: "linkedin-title-snippet",
                                on: {
                                  click: function ($event) {
                                    _vm.activeEdit.snippet_title = true
                                    _vm.$forceUpdate()
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/linkedin_link_title.svg"),
                                  },
                                }),
                                _vm._v(
                                  "\n        Modifier le titre de l'article\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                        ["linkedin", "facebook", "whatsapp"].includes(
                          _vm.page.network
                        ) && _vm.live
                          ? _c(
                              "label",
                              {
                                staticClass: "linkedin-image-snippet",
                                attrs: { for: "linkedin-snippet" },
                              },
                              [
                                _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      text: "Modifier l'image du lien",
                                      position: "top",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/linkedin_snippet.svg"),
                                        alt: "",
                                      },
                                    }),
                                    _vm._v("\n               \n            "),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "linkedin-close-snippet",
                            on: {
                              click: function ($event) {
                                _vm.activeEdit.snippet = false
                                _vm.$forceUpdate()
                              },
                            },
                          },
                          [_vm._v("x")]
                        ),
                        _c("input", {
                          attrs: {
                            id: "linkedin-snippet",
                            type: "file",
                            hidden: "",
                          },
                          on: { change: _vm.selectLinkedinSnippet },
                        }),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm.typePost !== "video" &&
              _vm.post.meta &&
              (_vm.post.meta.og ||
                (_vm.post.meta.og.images && _vm.post.meta.og.images[0]))
            ? _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-link-thumbnail",
                    on: {
                      click: function ($event) {
                        return _vm.goToLink(
                          _vm.live
                            ? null
                            : _vm.post.meta.og.url || _vm.post.meta.og.site
                        )
                      },
                    },
                  },
                  [
                    _c("img", {
                      staticClass: "card-img-top",
                      attrs: {
                        src:
                          _vm.post.meta.og.image ||
                          _vm.post.meta.og.images[0].url,
                        alt: _vm.post.meta.og.title,
                      },
                    }),
                    _c("div", { staticClass: "card-block" }, [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.removeHtml(_vm.post.meta.og.title))),
                      ]),
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          _vm._s(_vm.removeHtml(_vm.post.meta.og.description))
                        ),
                      ]),
                      _vm.page.network !== "telegram"
                        ? _c("p", { staticClass: "card-sitename" }, [
                            _vm._v(
                              _vm._s(
                                _vm.page.network === "bluesky"
                                  ? _vm.getHostName(_vm.post.url)
                                  : _vm.post.meta.og.site_name
                              )
                            ),
                          ])
                        : _vm._e(),
                    ]),
                  ]
                ),
              ])
            : _vm.typePost === "standard" &&
              _vm.post.meta &&
              _vm.post.content.shareMediaCategory == "ARTICLE"
            ? _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-link-thumbnail",
                    on: {
                      click: function ($event) {
                        return _vm.goToLink(
                          _vm.live ? null : _vm.post.meta.og.site
                        )
                      },
                    },
                  },
                  [
                    _vm.post.meta && _vm.post.meta.og && _vm.post.meta.og.image
                      ? _c("img", {
                          staticClass: "card-img-top",
                          attrs: {
                            src: _vm.post.meta.og.image,
                            alt: _vm.post.meta.og.title,
                          },
                          on: { error: _vm.replaceByDefault },
                        })
                      : _vm.page.network === "linkedin" &&
                        _vm.post.meta &&
                        _vm.post.meta.images &&
                        _vm.post.meta.images[0] &&
                        _vm.post.meta.images[0].url
                      ? _c("img", {
                          attrs: { src: _vm.post.meta.images[0].url },
                          on: { error: _vm.replaceByDefault },
                        })
                      : _vm._e(),
                    _c("div", { staticClass: "card-block" }, [
                      _c("h4", { staticClass: "card-title" }, [
                        _vm._v(_vm._s(_vm.removeHtml(_vm.post.meta.og.title))),
                      ]),
                      _c("p", { staticClass: "card-text" }, [
                        _vm._v(
                          _vm._s(_vm.removeHtml(_vm.post.meta.og.description))
                        ),
                      ]),
                    ]),
                  ]
                ),
              ])
            : _vm.typePost === "standard" &&
              !["twitter", "telegram"].includes(_vm.page.network) &&
              _vm.meta &&
              _vm.meta.meta &&
              _vm.meta.meta.title
            ? _c("div", { staticClass: "card" }, [
                _c(
                  "div",
                  {
                    staticClass: "card-link-thumbnail",
                    on: {
                      click: function ($event) {
                        return _vm.goToLink(_vm.live ? null : _vm.getUrlWithUtm)
                      },
                    },
                  },
                  [
                    _vm.meta &&
                    _vm.meta.og &&
                    !["google"].includes(_vm.page.network)
                      ? _c("div", { staticClass: "card-block" }, [
                          _c("h4", { staticClass: "card-title" }, [
                            _vm._v(
                              _vm._s(
                                _vm.removeHtml(
                                  _vm.meta.og.title ||
                                    ["linkedin", "facebook"].includes(
                                      _vm.page.network
                                    )
                                    ? _vm.meta.meta.title
                                    : null
                                )
                              )
                            ),
                          ]),
                          _c("p", { staticClass: "card-text" }, [
                            _vm._v(
                              _vm._s(
                                _vm.removeHtml(
                                  _vm.meta.og.description ||
                                    ["linkedin", "facebook"].includes(
                                      _vm.page.network
                                    )
                                    ? _vm.meta.meta.description
                                    : null
                                )
                              )
                            ),
                          ]),
                          !["telegram"].includes(_vm.page.network)
                            ? _c("p", { staticClass: "card-sitename" }, [
                                _vm._v(
                                  _vm._s(
                                    _vm.meta.og.site_name ||
                                      _vm.getHostName(_vm.post.url)
                                  )
                                ),
                              ])
                            : _vm._e(),
                        ])
                      : _vm._e(),
                  ]
                ),
              ])
            : _vm.typePost === "standard" && _vm.post.url && !_vm.showLoader
            ? _c(
                "div",
                { staticClass: "card" },
                [
                  _c(
                    "div",
                    {
                      staticClass: "card-link-thumbnail",
                      on: {
                        click: function ($event) {
                          return _vm.goToLink(
                            _vm.live ? null : _vm.getUrlWithUtm
                          )
                        },
                      },
                    },
                    [
                      _vm.page.network === "telegram"
                        ? _c("p", { staticClass: "card-sitename" }, [
                            _vm._v(_vm._s(_vm.getHostName(_vm.post.url))),
                          ])
                        : _vm._e(),
                      ["linkedin", "facebook", "whatsapp"].includes(
                        _vm.page.network
                      ) && _vm.injectedSnippet
                        ? _c("img", {
                            staticClass: "card-img-top",
                            style:
                              _vm.page.network === "facebook" &&
                              "aspect-ratio: 1.91; object-fit: cover;",
                            attrs: {
                              src: _vm.getUrlObjectSnippet(_vm.injectedSnippet),
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.live && !_vm.activeEdit.snippet
                                  ? _vm.showEditPost("snippet")
                                  : null
                              },
                            },
                          })
                        : ["linkedin", "facebook", "whatsapp"].includes(
                            _vm.page.network
                          ) &&
                          _vm.post.page &&
                          _vm.post.page[0] &&
                          _vm.post.page[0].snippet
                        ? _c("img", {
                            staticClass: "card-img-top",
                            style:
                              _vm.page.network === "facebook" &&
                              "aspect-ratio: 1.91; object-fit: cover;",
                            attrs: {
                              src:
                                _vm.post.enclosure || _vm.post.page[0].snippet,
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.live && !_vm.activeEdit.snippet
                                  ? _vm.showEditPost("snippet")
                                  : null
                              },
                            },
                          })
                        : ["linkedin", "facebook", "whatsapp"].includes(
                            _vm.page.network
                          )
                        ? _c("img", {
                            staticClass: "error",
                            attrs: {
                              src: require("../../assets/img/no-picture.png"),
                            },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                _vm.live && !_vm.activeEdit.snippet
                                  ? _vm.showEditPost("snippet")
                                  : null
                              },
                            },
                          })
                        : _vm._e(),
                      !["google"].includes(_vm.page.network)
                        ? _c(
                            "div",
                            { staticClass: "card-block" },
                            [
                              ["linkedin", "whatsapp"].includes(
                                _vm.page.network
                              ) &&
                              _vm.post &&
                              _vm.post.page &&
                              _vm.post.page[0] &&
                              _vm.post.page[0].snippet_title
                                ? _c(
                                    "h4",
                                    {
                                      staticClass: "card-title a",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          _vm.live &&
                                          !_vm.activeEdit.snippet_title
                                            ? _vm.showEditPost("snippet_title")
                                            : null
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(_vm.post.page[0].snippet_title)
                                      ),
                                    ]
                                  )
                                : _vm.activeEdit.snippet_title
                                ? _c(
                                    "div",
                                    { staticClass: "edit-snippet-input" },
                                    [
                                      _c("textarea", {
                                        ref: "snippetTitle",
                                        staticClass: "card-title",
                                        domProps: { value: _vm.snippetTitle },
                                        on: {
                                          input: (e) => {
                                            e.target.style.height = "auto"
                                            e.target.style.height =
                                              e.target.scrollHeight +
                                              (e.target.offsetHeight -
                                                e.target.clientHeight) +
                                              "px"
                                          },
                                        },
                                      }),
                                      _c("vs-button", {
                                        staticClass: "close",
                                        attrs: {
                                          "vs-type": "filled",
                                          icon: "close",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            _vm.activeEdit.snippet_title = false
                                            _vm.$forceUpdate()
                                          },
                                        },
                                      }),
                                      _c("vs-button", {
                                        attrs: {
                                          "vs-type": "filled",
                                          icon: "check",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.validateSnippetTitle.apply(
                                              null,
                                              arguments
                                            )
                                          },
                                        },
                                      }),
                                    ],
                                    1
                                  )
                                : _c(
                                    "h4",
                                    {
                                      staticClass: "card-title b",
                                      on: {
                                        click: function ($event) {
                                          $event.preventDefault()
                                          ;[
                                            "linkedin",
                                            "facebook",
                                            "whatsapp",
                                          ].includes(_vm.page.network) &&
                                          _vm.live &&
                                          !_vm.activeEdit.snippet_title
                                            ? _vm.showEditPost("snippet_title")
                                            : null
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.injectedSnippetTitle ||
                                            _vm.snippetTitle ||
                                            _vm
                                              .getHostName(_vm.post.url)
                                              .replace("www.", "")
                                              .toUpperCase()
                                        )
                                      ),
                                    ]
                                  ),
                              ["linkedin", "facebook", "whatsapp"].includes(
                                _vm.page.network
                              ) && _vm.live
                                ? _c(
                                    "Tooltip",
                                    {
                                      directives: [
                                        {
                                          name: "show",
                                          rawName: "v-show",
                                          value:
                                            _vm.live &&
                                            !_vm.doScreenshot &&
                                            !_vm.activeEdit.snippet_title,
                                          expression:
                                            "live && !doScreenshot && !activeEdit.snippet_title",
                                        },
                                      ],
                                      staticClass: "edit-snippet-title",
                                      attrs: {
                                        text: _vm.$t(
                                          "dash.post.overlay.edit.snippet.title"
                                        ),
                                        position: "left",
                                      },
                                    },
                                    [
                                      _c("vs-button", {
                                        attrs: {
                                          "vs-type": "filled",
                                          icon: "edit",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.showEditPost(
                                              "snippet_title"
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v("\n           \n        "),
                                    ],
                                    1
                                  )
                                : _vm._e(),
                              _c("p", { staticClass: "card-text" }),
                              !["telegram"].includes(_vm.page.network)
                                ? _c("p", { staticClass: "card-sitename" }, [
                                    _vm._v(
                                      _vm._s(_vm.getHostName(_vm.post.url))
                                    ),
                                  ])
                                : _vm._e(),
                            ],
                            1
                          )
                        : _vm._e(),
                    ]
                  ),
                  ["linkedin", "facebook", "whatsapp"].includes(
                    _vm.page.network
                  ) && _vm.live
                    ? _c(
                        "Tooltip",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value:
                                _vm.live &&
                                !_vm.doScreenshot &&
                                !_vm.activeEdit.snippet,
                              expression:
                                "live && !doScreenshot && !activeEdit.snippet",
                            },
                          ],
                          staticClass: "edit-snippet",
                          attrs: {
                            text: _vm.$t("dash.post.overlay.edit.snippet"),
                            position: "left",
                          },
                        },
                        [
                          _c("vs-button", {
                            attrs: { "vs-type": "filled", icon: "edit" },
                            on: {
                              click: function ($event) {
                                $event.preventDefault()
                                return _vm.showEditPost("snippet")
                              },
                            },
                          }),
                          _vm._v("\n       \n    "),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.activeEdit.snippet
                    ? _c("div", { staticClass: "linkedin-snippet" }, [
                        ["linkedin", "facebook", "whatsapp"].includes(
                          _vm.page.network
                        ) && _vm.live
                          ? _c(
                              "span",
                              {
                                staticClass: "linkedin-title-snippet",
                                on: {
                                  click: function ($event) {
                                    _vm.activeEdit.snippet_title = true
                                    _vm.$forceUpdate()
                                  },
                                },
                              },
                              [
                                _c("img", {
                                  attrs: {
                                    src: require("../../assets/img/linkedin_link_title.svg"),
                                  },
                                }),
                                _vm._v(
                                  "\n        Modifier le titre de l'article\n      "
                                ),
                              ]
                            )
                          : _vm._e(),
                        ["linkedin", "facebook", "whatsapp"].includes(
                          _vm.page.network
                        ) && _vm.live
                          ? _c(
                              "label",
                              {
                                staticClass: "linkedin-image-snippet",
                                attrs: { for: "linkedin-snippet" },
                              },
                              [
                                _c(
                                  "Tooltip",
                                  {
                                    attrs: {
                                      text: "Modifier l'image du lien",
                                      position: "top",
                                    },
                                  },
                                  [
                                    _c("img", {
                                      attrs: {
                                        src: require("../../assets/img/linkedin_snippet.svg"),
                                        alt: "",
                                      },
                                    }),
                                    _vm._v("\n               \n            "),
                                  ]
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "span",
                          {
                            staticClass: "linkedin-close-snippet",
                            on: {
                              click: function ($event) {
                                _vm.activeEdit.snippet = false
                                _vm.$forceUpdate()
                              },
                            },
                          },
                          [_vm._v("x")]
                        ),
                        _c("input", {
                          attrs: {
                            id: "linkedin-snippet",
                            type: "file",
                            hidden: "",
                          },
                          on: { change: _vm.selectLinkedinSnippet },
                        }),
                      ])
                    : _vm._e(),
                ],
                1
              )
            : _vm._e(),
          _vm.showLoader
            ? _c("component-loader", {
                attrs: { progress: 90, unlimitedProgress: true },
              })
            : _vm._e(),
          _vm.page.network === "instagram" &&
          _vm.typePost !== "story" &&
          ((_vm.productTags && _vm.productTags.length) ||
            (_vm.post.productTags && _vm.post.productTags.length)) &&
          (_vm.image || _vm.post.video || _vm.post.enclosure || _vm.post.url)
            ? _c(
                "Tooltip",
                {
                  staticClass: "tags",
                  style: { top: _vm.typePost === "video" ? "-80px" : "-50px" },
                  attrs: {
                    position: "top",
                    text: _vm.productTags
                      ? _vm.productTags.length +
                        " " +
                        _vm.$t("dash.post.text.product") +
                        (_vm.productTags.length > 1 ? "s" : "")
                      : _vm.post.productTags.length +
                        " " +
                        _vm.$t("dash.post.text.product") +
                        (_vm.productTags.length > 1 ? "s" : ""),
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("local_mall"),
                  ]),
                  _vm._v("\n     \n  "),
                ]
              )
            : _vm._e(),
          _vm.page.network === "instagram" &&
          (_vm.userTags || _vm.post.userTags) &&
          (_vm.image || _vm.post.video || _vm.post.enclosure || _vm.post.url)
            ? _c(
                "Tooltip",
                {
                  staticClass: "tags",
                  style: { top: _vm.typePost === "video" ? "-80px" : "-50px" },
                  attrs: {
                    position: "top",
                    text: _vm.userTags
                      ? _vm.userTags.list.map((e) => e.username).join(", ")
                      : _vm.post.userTags.list
                          .map((e) => e.username)
                          .join(", "),
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("person"),
                  ]),
                  _vm._v("\n     \n  "),
                ]
              )
            : _vm.page.network === "instagram" &&
              _vm.post.page &&
              _vm.post.page[0] &&
              _vm.post.page[0].userTags
            ? _c(
                "Tooltip",
                {
                  staticClass: "tags",
                  style: { top: _vm.typePost === "video" ? "-80px" : "-50px" },
                  attrs: {
                    text: JSON.parse(_vm.post.page[0].userTags)
                      .list.map((e) => e.username)
                      .join(", "),
                  },
                },
                [
                  _c("i", { staticClass: "material-icons" }, [
                    _vm._v("person"),
                  ]),
                  _vm._v("\n     \n  "),
                ]
              )
            : _vm._e(),
          !_vm.moderation && !_vm.disableCTA
            ? _c(
                "div",
                { staticClass: "cta" },
                [
                  _vm.page.network === "facebook"
                    ? [
                        _c("div", { staticClass: "like" }),
                        _c("div", { staticClass: "comment" }),
                        _c("div", { staticClass: "share" }),
                      ]
                    : _vm.page.network === "twitter"
                    ? [
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "blue",
                              attrs: { viewBox: "0 0 24 24" },
                            },
                            [
                              _c("g", [
                                _c("path", {
                                  attrs: {
                                    d: "M14.046 2.242l-4.148-.01h-.002c-4.374 0-7.8 3.427-7.8 7.802 0 4.098 3.186 7.206 7.465 7.37v3.828c0 .108.044.286.12.403.142.225.384.347.632.347.138 0 .277-.038.402-.118.264-.168 6.473-4.14 8.088-5.506 1.902-1.61 3.04-3.97 3.043-6.312v-.017c-.006-4.367-3.43-7.787-7.8-7.788zm3.787 12.972c-1.134.96-4.862 3.405-6.772 4.643V16.67c0-.414-.335-.75-.75-.75h-.396c-3.66 0-6.318-2.476-6.318-5.886 0-3.534 2.768-6.302 6.3-6.302l4.147.01h.002c3.532 0 6.3 2.766 6.302 6.296-.003 1.91-.942 3.844-2.514 5.176z",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "green",
                              attrs: { viewBox: "0 0 24 24" },
                            },
                            [
                              _c("g", [
                                _c("path", {
                                  attrs: {
                                    d: "M23.77 15.67c-.292-.293-.767-.293-1.06 0l-2.22 2.22V7.65c0-2.068-1.683-3.75-3.75-3.75h-5.85c-.414 0-.75.336-.75.75s.336.75.75.75h5.85c1.24 0 2.25 1.01 2.25 2.25v10.24l-2.22-2.22c-.293-.293-.768-.293-1.06 0s-.294.768 0 1.06l3.5 3.5c.145.147.337.22.53.22s.383-.072.53-.22l3.5-3.5c.294-.292.294-.767 0-1.06zm-10.66 3.28H7.26c-1.24 0-2.25-1.01-2.25-2.25V6.46l2.22 2.22c.148.147.34.22.532.22s.384-.073.53-.22c.293-.293.293-.768 0-1.06l-3.5-3.5c-.293-.294-.768-.294-1.06 0l-3.5 3.5c-.294.292-.294.767 0 1.06s.767.293 1.06 0l2.22-2.22V16.7c0 2.068 1.683 3.75 3.75 3.75h5.85c.414 0 .75-.336.75-.75s-.337-.75-.75-.75z",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "red",
                              attrs: { viewBox: "0 0 24 24" },
                            },
                            [
                              _c("g", [
                                _c("path", {
                                  attrs: {
                                    d: "M12 21.638h-.014C9.403 21.59 1.95 14.856 1.95 8.478c0-3.064 2.525-5.754 5.403-5.754 2.29 0 3.83 1.58 4.646 2.73.814-1.148 2.354-2.73 4.645-2.73 2.88 0 5.404 2.69 5.404 5.755 0 6.376-7.454 13.11-10.037 13.157H12zM7.354 4.225c-2.08 0-3.903 1.988-3.903 4.255 0 5.74 7.034 11.596 8.55 11.658 1.518-.062 8.55-5.917 8.55-11.658 0-2.267-1.823-4.255-3.903-4.255-2.528 0-3.94 2.936-3.952 2.965-.23.562-1.156.562-1.387 0-.014-.03-1.425-2.965-3.954-2.965z",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "blue",
                              attrs: { viewBox: "0 0 24 24" },
                            },
                            [
                              _c("g", [
                                _c("path", {
                                  attrs: {
                                    d: "M17.53 7.47l-5-5c-.293-.293-.768-.293-1.06 0l-5 5c-.294.293-.294.768 0 1.06s.767.294 1.06 0l3.72-3.72V15c0 .414.336.75.75.75s.75-.336.75-.75V4.81l3.72 3.72c.146.147.338.22.53.22s.384-.072.53-.22c.293-.293.293-.767 0-1.06z",
                                  },
                                }),
                                _c("path", {
                                  attrs: {
                                    d: "M19.708 21.944H4.292C3.028 21.944 2 20.916 2 19.652V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 .437.355.792.792.792h15.416c.437 0 .792-.355.792-.792V14c0-.414.336-.75.75-.75s.75.336.75.75v5.652c0 1.264-1.028 2.292-2.292 2.292z",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "blue",
                              attrs: { viewBox: "0 0 24 24" },
                            },
                            [
                              _c("g", [
                                _c("path", {
                                  attrs: {
                                    d: "M12 22c-.414 0-.75-.336-.75-.75V2.75c0-.414.336-.75.75-.75s.75.336.75.75v18.5c0 .414-.336.75-.75.75zm5.14 0c-.415 0-.75-.336-.75-.75V7.89c0-.415.335-.75.75-.75s.75.335.75.75v13.36c0 .414-.337.75-.75.75zM6.86 22c-.413 0-.75-.336-.75-.75V10.973c0-.414.337-.75.75-.75s.75.336.75.75V21.25c0 .414-.335.75-.75.75z",
                                  },
                                }),
                              ]),
                            ]
                          ),
                        ]),
                      ]
                    : _vm.page.network === "linkedin"
                    ? [
                        _c("div", [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                "data-supported-dps": "24x24",
                                fill: "currentColor",
                                width: "24",
                                height: "24",
                                focusable: "false",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M17.51 11l-2.15-3a14.81 14.81 0 01-2.25-5.29L12.74 1H10.5A2.5 2.5 0 008 3.5v.58a9 9 0 00.32 2.39L9 9H4.66A2.61 2.61 0 002 11.4a2.48 2.48 0 00.39 1.43 2.48 2.48 0 00.69 3.39 2.46 2.46 0 001.45 2.92 2.47 2.47 0 000 .36A2.5 2.5 0 007 22h4.52a8 8 0 001.94-.24l3-.76H21V11h-3.49zM19 19h-2.12l-3.41.82A6 6 0 0112 20H7a.9.9 0 01-.9-.89v-.14l.15-1-1-.4a.9.9 0 01-.55-.83.93.93 0 010-.22l.3-.95-.73-.57a.9.9 0 01-.39-.74.88.88 0 01.12-.44l.46-.72-.46-.72a.88.88 0 01-.14-.51 1 1 0 011-.87h6.64l-1.3-4.7a9 9 0 01-.33-2.37v-.55a.5.5 0 01.5-.5h.95a17.82 17.82 0 002.52 6.22L16.6 13H19v6z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                "data-supported-dps": "24x24",
                                fill: "currentColor",
                                width: "24",
                                height: "24",
                                focusable: "false",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M18 10H6V9h12v1zm4-5v17l-5-4H3a1 1 0 01-1-1V5a1 1 0 011-1h18a1 1 0 011 1zm-2 1H4v10h13.7l2.3 1.84V6zm-4 6H8v1h8v-1z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                "data-supported-dps": "24x24",
                                fill: "currentColor",
                                width: "24",
                                height: "24",
                                focusable: "false",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M24 12a1.18 1.18 0 00-.36-.84L14 2v6h-3A10 10 0 001 18v4h1.87A6.11 6.11 0 019 16h5v6l9.63-9.14A1.18 1.18 0 0024 12zm-8 5.54V14H9a8.15 8.15 0 00-6 2.84A8 8 0 0111 10h5V6.48L21.81 12z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              attrs: {
                                xmlns: "http://www.w3.org/2000/svg",
                                viewBox: "0 0 24 24",
                                "data-supported-dps": "24x24",
                                fill: "currentColor",
                                width: "24",
                                height: "24",
                                focusable: "false",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M19.27 4.73l-4.91 12.9-2.18-5.81-5.81-2.18 12.9-4.91m2-2.73a1 1 0 00-.28 0L1 9.65l9.71 3.64L14.35 23 22 3.05A.78.78 0 0021.23 2z",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    : _vm.page.network === "instagram"
                    ? [
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "_8-yf5",
                              attrs: {
                                "aria-label": "J’aime",
                                fill: "#262626",
                                height: "24",
                                viewBox: "0 0 48 48",
                                width: "24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M34.6 6.1c5.7 0 10.4 5.2 10.4 11.5 0 6.8-5.9 11-11.5 16S25 41.3 24 41.9c-1.1-.7-4.7-4-9.5-8.3-5.7-5-11.5-9.2-11.5-16C3 11.3 7.7 6.1 13.4 6.1c4.2 0 6.5 2 8.1 4.3 1.9 2.6 2.2 3.9 2.5 3.9.3 0 .6-1.3 2.5-3.9 1.6-2.3 3.9-4.3 8.1-4.3m0-3c-4.5 0-7.9 1.8-10.6 5.6-2.7-3.7-6.1-5.5-10.6-5.5C6 3.1 0 9.6 0 17.6c0 7.3 5.4 12 10.6 16.5.6.5 1.3 1.1 1.9 1.7l2.3 2c4.4 3.9 6.6 5.9 7.6 6.5.5.3 1.1.5 1.6.5.6 0 1.1-.2 1.6-.5 1-.6 2.8-2.2 7.8-6.8l2-1.8c.7-.6 1.3-1.2 2-1.7C42.7 29.6 48 25 48 17.6c0-8-6-14.5-13.4-14.5z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "_8-yf5",
                              attrs: {
                                "aria-label": "Commenter",
                                fill: "#262626",
                                height: "24",
                                viewBox: "0 0 48 48",
                                width: "24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  "clip-rule": "evenodd",
                                  d: "M47.5 46.1l-2.8-11c1.8-3.3 2.8-7.1 2.8-11.1C47.5 11 37 .5 24 .5S.5 11 .5 24 11 47.5 24 47.5c4 0 7.8-1 11.1-2.8l11 2.8c.8.2 1.6-.6 1.4-1.4zm-3-22.1c0 4-1 7-2.6 10-.2.4-.3.9-.2 1.4l2.1 8.4-8.3-2.1c-.5-.1-1-.1-1.4.2-1.8 1-5.2 2.6-10 2.6-11.4 0-20.6-9.2-20.6-20.5S12.7 3.5 24 3.5 44.5 12.7 44.5 24z",
                                  "fill-rule": "evenodd",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "_8-yf5",
                              attrs: {
                                "aria-label": "Partager la publication",
                                fill: "#262626",
                                height: "24",
                                viewBox: "0 0 48 48",
                                width: "24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M47.8 3.8c-.3-.5-.8-.8-1.3-.8h-45C.9 3.1.3 3.5.1 4S0 5.2.4 5.7l15.9 15.6 5.5 22.6c.1.6.6 1 1.2 1.1h.2c.5 0 1-.3 1.3-.7l23.2-39c.4-.4.4-1 .1-1.5zM5.2 6.1h35.5L18 18.7 5.2 6.1zm18.7 33.6l-4.4-18.4L42.4 8.6 23.9 39.7z",
                                },
                              }),
                            ]
                          ),
                        ]),
                        _c("div", [
                          _c(
                            "svg",
                            {
                              staticClass: "_8-yf5",
                              attrs: {
                                "aria-label": "Enregistrer",
                                fill: "#262626",
                                height: "24",
                                viewBox: "0 0 48 48",
                                width: "24",
                              },
                            },
                            [
                              _c("path", {
                                attrs: {
                                  d: "M43.5 48c-.4 0-.8-.2-1.1-.4L24 29 5.6 47.6c-.4.4-1.1.6-1.6.3-.6-.2-1-.8-1-1.4v-45C3 .7 3.7 0 4.5 0h39c.8 0 1.5.7 1.5 1.5v45c0 .6-.4 1.2-.9 1.4-.2.1-.4.1-.6.1zM24 26c.8 0 1.6.3 2.2.9l15.8 16V3H6v39.9l15.8-16c.6-.6 1.4-.9 2.2-.9z",
                                },
                              }),
                            ]
                          ),
                        ]),
                      ]
                    : _vm._e(),
                ],
                2
              )
            : _vm._e(),
          ["instagram", "pinterest", "google", "youtube", "whatsapp"].includes(
            _vm.page.network
          ) && _vm.typePost !== "story"
            ? _c(
                "div",
                {
                  staticClass: "title",
                  class: [
                    {
                      lorem: _vm.post.title == "" && !_vm.moderation,
                      live: _vm.live,
                    },
                  ],
                },
                [
                  _vm.page.network === "instagram"
                    ? _c("b", [_vm._v(_vm._s(_vm.page.name))])
                    : _vm._e(),
                  !_vm.activeEdit.title
                    ? _c(
                        "div",
                        {
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.live && !_vm.activeEdit.title
                                ? _vm.showEditPost("title")
                                : null
                            },
                          },
                        },
                        [
                          _vm.activePrefixSuffix &&
                          _vm.bot &&
                          _vm.bot.hashtagPrefix &&
                          _vm.post.title != ""
                            ? _c("span", {
                                staticClass: "hashtag-prefix",
                                domProps: {
                                  innerHTML: _vm._s(
                                    `${_vm.addHashtagsLinks(
                                      _vm.bot.hashtagPrefix
                                    )} `
                                  ),
                                },
                              })
                            : _vm._e(),
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.handleNewLine(
                                  _vm.getMessageToPost(_vm.post)
                                )
                              ),
                            },
                          }),
                          _vm.activePrefixSuffix &&
                          _vm.bot &&
                          _vm.bot.hashtag &&
                          _vm.post.title != ""
                            ? _c("span", {
                                staticClass: "hashtag-suffix",
                                domProps: {
                                  innerHTML: _vm._s(
                                    ` ${_vm.addHashtagsLinks(_vm.bot.hashtag)}`
                                  ),
                                },
                              })
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm.live && !_vm.doScreenshot && _vm.post.title != ""
                    ? _c("div", { staticClass: "live-title" }, [
                        _c(
                          "span",
                          { staticClass: "btn-edit" },
                          [
                            _c(
                              "Tooltip",
                              {
                                attrs: {
                                  text: _vm.$t(
                                    "dash.post.overlay.edit.message"
                                  ),
                                  position: "top",
                                },
                              },
                              [
                                _c("vs-button", {
                                  directives: [
                                    {
                                      name: "show",
                                      rawName: "v-show",
                                      value: !_vm.activeEdit.title,
                                      expression: "!activeEdit.title",
                                    },
                                  ],
                                  attrs: { "vs-type": "filled", icon: "edit" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.showEditPost("title")
                                    },
                                  },
                                }),
                                _vm._v("\n            \n        "),
                              ],
                              1
                            ),
                          ],
                          1
                        ),
                        _vm.activeEdit.title
                          ? _c(
                              "div",
                              { staticClass: "edit-title" },
                              [
                                _c("vs-button", {
                                  staticClass: "close",
                                  attrs: { "vs-type": "filled", icon: "close" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      _vm.activeEdit.title = false
                                    },
                                  },
                                }),
                                _c("vs-button", {
                                  staticClass: "save",
                                  attrs: { "vs-type": "filled", icon: "check" },
                                  on: {
                                    click: function ($event) {
                                      $event.preventDefault()
                                      return _vm.editPost("title")
                                    },
                                  },
                                }),
                                _c(
                                  "div",
                                  {
                                    directives: [
                                      {
                                        name: "click-outside",
                                        rawName: "v-click-outside",
                                        value: _vm.hideEmojiPicker,
                                        expression: "hideEmojiPicker",
                                      },
                                    ],
                                    staticClass: "textarea-emoji-picker",
                                  },
                                  [
                                    _vm.page.network !== "bluesky"
                                      ? _c(
                                          "div",
                                          {
                                            staticClass: "styles-text-buttons",
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticClass: "emoji-trigger",
                                                class: {
                                                  triggered: _vm
                                                    .styledText()
                                                    .includes("bold"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.styleSelection(
                                                      "bold"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      viewBox: "0 0 20 20",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        fill: "#888888",
                                                        d: "M3 19V1h8a5 5 0 0 1 3.88 8.16A5.5 5.5 0 0 1 11.5 19H3zm7.5-8H7v5h3.5a2.5 2.5 0 1 0 0-5zM7 4v4h3a2 2 0 1 0 0-4H7z",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "emoji-trigger",
                                                class: {
                                                  triggered: _vm
                                                    .styledText()
                                                    .includes("italic"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.styleSelection(
                                                      "italic"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      viewBox: "0 0 20 20",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        fill: "#888888",
                                                        d: "M 7 4 L 7 5 L 9.9921875 5 L 8 15.955078 L 8 16 L 5 16 L 5 17 L 12 17 L 12 16 L 9.0078125 16 L 11 5.0449219 L 11 5 L 14 5 L 14 4 L 7 4 z ",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticClass: "emoji-trigger",
                                                class: {
                                                  triggered: _vm
                                                    .styledText()
                                                    .includes("underline"),
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.styleSelection(
                                                      "underline"
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _c(
                                                  "svg",
                                                  {
                                                    attrs: {
                                                      viewBox: "0 0 20 20",
                                                      xmlns:
                                                        "http://www.w3.org/2000/svg",
                                                    },
                                                  },
                                                  [
                                                    _c("path", {
                                                      attrs: {
                                                        fill: "#888888",
                                                        d: "M6 3.5C6 3.22386 5.77614 3 5.5 3C5.22386 3 5 3.22386 5 3.5V9.95455C5 12.7363 7.23385 15 10 15C12.7661 15 15 12.7363 15 9.95455V3.5C15 3.22386 14.7761 3 14.5 3C14.2239 3 14 3.22386 14 3.5V9.95455C14 12.1935 12.2044 14 10 14C7.79559 14 6 12.1935 6 9.95455V3.5Z",
                                                      },
                                                    }),
                                                    _c("path", {
                                                      attrs: {
                                                        fill: "#888888",
                                                        d: "M5 16.5C5 16.2239 5.22386 16 5.5 16H14.5C14.7761 16 15 16.2239 15 16.5C15 16.7761 14.7761 17 14.5 17H5.5C5.22386 17 5 16.7761 5 16.5Z",
                                                      },
                                                    }),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm.page.network !== "bluesky"
                                      ? _c("picker", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: _vm.showEmojiPicker,
                                              expression: "showEmojiPicker",
                                            },
                                          ],
                                          attrs: {
                                            data: _vm.emojiIndex,
                                            title: "Pick your emoji...",
                                            emoji: "point_up",
                                          },
                                          on: { select: _vm.addEmoji },
                                        })
                                      : _vm._e(),
                                    _vm.page.network !== "bluesky"
                                      ? _c(
                                          "span",
                                          {
                                            staticClass: "emoji-trigger",
                                            class: {
                                              triggered: _vm.showEmojiPicker,
                                            },
                                            on: {
                                              click: _vm.toggleEmojiPicker,
                                            },
                                          },
                                          [
                                            _c(
                                              "svg",
                                              {
                                                staticStyle: {
                                                  width: "20px",
                                                  height: "20px",
                                                },
                                                attrs: { viewBox: "0 0 24 24" },
                                              },
                                              [
                                                _c("path", {
                                                  attrs: {
                                                    fill: "#888888",
                                                    d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                  },
                                                }),
                                              ]
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "add-mention",
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowMentions(
                                              "Mention"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("@")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "add-mention add-hashtag",
                                        class: {
                                          disabled: !_vm.activeSearchHashtags,
                                        },
                                        on: {
                                          click: function ($event) {
                                            return _vm.toggleShowMentions(
                                              "Hashtag"
                                            )
                                          },
                                        },
                                      },
                                      [_vm._v("#")]
                                    ),
                                    _c(
                                      "span",
                                      {
                                        staticClass: "add-mention ai-generate",
                                        on: {
                                          click: function ($event) {
                                            return _vm.getAccrochesByAI()
                                          },
                                        },
                                      },
                                      [
                                        _c(
                                          "span",
                                          { staticClass: "material-icons" },
                                          [_vm._v("lightbulb_outline")]
                                        ),
                                      ]
                                    ),
                                    _c("vs-textarea", {
                                      ref: `inputTitle-${_vm.page.network_id}`,
                                      class: { input: true },
                                      attrs: {
                                        "vs-size": "large",
                                        color: "#B20564",
                                        name: "title",
                                        placeholder: _vm.$t(
                                          "dash.posts.overlay.description_placeholder"
                                        ),
                                        id: `inputTitle-${_vm.page.network_id}`,
                                      },
                                      on: {
                                        click: function ($event) {
                                          ;[_vm.checkAddMention()]
                                        },
                                        keyup: function ($event) {
                                          ;[
                                            _vm.checkTruncate(),
                                            _vm.checkAddMention(),
                                            _vm.textAreaAdjust(
                                              `inputTitle-${_vm.page.network_id}`
                                            ),
                                          ]
                                        },
                                      },
                                      model: {
                                        value: _vm.editValue.title,
                                        callback: function ($$v) {
                                          _vm.$set(_vm.editValue, "title", $$v)
                                        },
                                        expression: "editValue.title",
                                      },
                                    }),
                                    _vm.limitText()
                                      ? _c(
                                          "div",
                                          { staticClass: "vs-textarea--count" },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(
                                                  _vm.sizeCurrentMessage()
                                                ) +
                                                " / " +
                                                _vm._s(_vm.limitText()) +
                                                "\n          "
                                            ),
                                          ]
                                        )
                                      : _vm._e(),
                                  ],
                                  1
                                ),
                              ],
                              1
                            )
                          : _vm._e(),
                      ])
                    : _vm._e(),
                  (_vm.image ||
                    _vm.post.video ||
                    (_vm.post.page &&
                      _vm.post.page[0] &&
                      (_vm.post.page[0].enclosure ||
                        _vm.post.page[0].video))) &&
                  _vm.post.url &&
                  !["instagram", "google", "pinterest"].includes(
                    _vm.page.network
                  )
                    ? _c("div", [
                        _vm._v("\n       \n      "),
                        _c(
                          "a",
                          {
                            attrs: { href: _vm.getUrlWithUtm, target: "blank" },
                          },
                          [
                            _c("span", [
                              _vm._v(
                                _vm._s(_vm.getUrlWithUtm.substr(0, 42)) + "..."
                              ),
                            ]),
                          ]
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.page.network === "google" &&
          _vm.getUrlWithUtm &&
          _vm.getUrlWithUtm.length
            ? _c(
                "a",
                {
                  staticClass: "more",
                  attrs: { href: _vm.getUrlWithUtm, target: "_blank" },
                },
                [_vm._v("En savoir plus")]
              )
            : ["pinterest", "youtube"].includes(_vm.page.network) &&
              !_vm.getMessageToPostDescription(_vm.post) &&
              _vm.getMessageToPostDescription(_vm.post) != "null"
            ? _c("div", { staticClass: "description" }, [
                _c("span", {
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.handleNewLine(
                        _vm.getMessageToPostDescription(_vm.post),
                        false,
                        false,
                        true
                      )
                    ),
                  },
                }),
              ])
            : _vm._e(),
          _vm.post.status != "direct" &&
          ["instagram", "facebook", "linkedin", "twitter", "bluesky"].includes(
            _vm.page.network
          ) &&
          !(_vm.page.network == "instagram" && _vm.typePost == "story") &&
          ((_vm.post.page && _vm.post.page[0] && _vm.post.page[0].comments) ||
            (_vm.post.comments && _vm.post.comments.length))
            ? _c(
                "div",
                { staticClass: "comments", class: { live: _vm.live } },
                [
                  _c(
                    "ul",
                    _vm._l(
                      _vm.post.page &&
                        _vm.post.page[0] &&
                        _vm.post.page[0].comments
                        ? _vm.post.page[0].comments.data
                        : _vm.post.comments,
                      function (comment, idx) {
                        return _c(
                          "li",
                          {
                            directives: [
                              {
                                name: "show",
                                rawName: "v-show",
                                value:
                                  comment !== "" &&
                                  _vm.editValue["comment"] &&
                                  _vm.editValue["comment"][idx] !== false,
                                expression:
                                  "comment !== '' && (editValue['comment'] && editValue['comment'][idx] !== false)",
                              },
                            ],
                            key: idx,
                            staticClass: "comment",
                            class: { live: _vm.live },
                          },
                          [
                            _vm.page.network !== "twitter"
                              ? _c("page-image-avatar", {
                                  attrs: { page: _vm.page },
                                })
                              : _vm._e(),
                            _c("div", { staticClass: "content" }, [
                              _c("p", { staticClass: "page-name" }, [
                                _vm._v(
                                  _vm._s(
                                    `${
                                      _vm.page.network === "twitter" ? "@" : ""
                                    }${_vm.page.name}`
                                  )
                                ),
                              ]),
                              _c("p", {
                                staticClass: "message",
                                domProps: {
                                  innerHTML: _vm._s(
                                    _vm.handleNewLine(
                                      _vm.editValue["comment"] &&
                                        _vm.editValue["comment"][idx]
                                        ? _vm.editValue["comment"][idx]
                                        : _vm.editPostValue &&
                                          _vm.editPostValue.filter(
                                            (e) => e.page === _vm.page.id
                                          )[0] &&
                                          _vm.editPostValue.filter(
                                            (e) => e.page === _vm.page.id
                                          )[0]["comment"] &&
                                          _vm.editPostValue.filter(
                                            (e) => e.page === _vm.page.id
                                          )[0]["comment"][idx]
                                        ? _vm.editPostValue.filter(
                                            (e) => e.page === _vm.page.id
                                          )[0]["comment"][idx]
                                        : comment,
                                      false,
                                      true
                                    )
                                  ),
                                },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.live &&
                                    (_vm.activeEdit.comment === false ||
                                      _vm.activeEdit.comment !== idx)
                                      ? _vm.showEditPost("comment", idx)
                                      : null
                                  },
                                },
                              }),
                              _vm.live && !_vm.doScreenshot && comment != ""
                                ? _c("div", { staticClass: "live-title" }, [
                                    _c(
                                      "span",
                                      { staticClass: "btn-edit" },
                                      [
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.post.overlay.edit.comment"
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c("vs-button", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.activeEdit.comment ===
                                                      false ||
                                                    _vm.activeEdit.comment !==
                                                      idx,
                                                  expression:
                                                    "activeEdit.comment === false || activeEdit.comment !== idx",
                                                },
                                              ],
                                              attrs: {
                                                "vs-type": "filled",
                                                icon: "edit",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.showEditPost(
                                                    "comment",
                                                    idx
                                                  )
                                                },
                                              },
                                            }),
                                            _vm._v(
                                              "\n                  \n              "
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "Tooltip",
                                          {
                                            attrs: {
                                              text: _vm.$t(
                                                "dash.post.overlay.edit.comment.remove"
                                              ),
                                              position: "top",
                                            },
                                          },
                                          [
                                            _c("vs-button", {
                                              directives: [
                                                {
                                                  name: "show",
                                                  rawName: "v-show",
                                                  value:
                                                    _vm.activeEdit.comment ===
                                                      false ||
                                                    _vm.activeEdit.comment !==
                                                      idx,
                                                  expression:
                                                    "activeEdit.comment === false || activeEdit.comment !== idx",
                                                },
                                              ],
                                              staticClass: "close",
                                              attrs: {
                                                "vs-type": "filled",
                                                icon: "close",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.removeComment(idx)
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                    _vm.activeEdit.comment !== false &&
                                    _vm.activeEdit.comment == idx
                                      ? _c(
                                          "div",
                                          { staticClass: "edit-title" },
                                          [
                                            _c("vs-button", {
                                              staticClass: "close",
                                              attrs: {
                                                "vs-type": "filled",
                                                icon: "close",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  _vm.activeEdit.comment = false
                                                },
                                              },
                                            }),
                                            _c("vs-button", {
                                              staticClass: "save",
                                              attrs: {
                                                "vs-type": "filled",
                                                icon: "check",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  $event.preventDefault()
                                                  return _vm.editPost(
                                                    "comment",
                                                    null,
                                                    idx
                                                  )
                                                },
                                              },
                                            }),
                                            _c(
                                              "div",
                                              {
                                                directives: [
                                                  {
                                                    name: "click-outside",
                                                    rawName: "v-click-outside",
                                                    value: _vm.hideEmojiPicker,
                                                    expression:
                                                      "hideEmojiPicker",
                                                  },
                                                ],
                                                staticClass:
                                                  "textarea-emoji-picker",
                                              },
                                              [
                                                _vm.page.network !== "bluesky"
                                                  ? _c("picker", {
                                                      directives: [
                                                        {
                                                          name: "show",
                                                          rawName: "v-show",
                                                          value:
                                                            _vm.showEmojiPicker,
                                                          expression:
                                                            "showEmojiPicker",
                                                        },
                                                      ],
                                                      attrs: {
                                                        data: _vm.emojiIndex,
                                                        title:
                                                          "Pick your emoji...",
                                                        emoji: "point_up",
                                                      },
                                                      on: {
                                                        select: (e) =>
                                                          _vm.addEmoji(e, idx),
                                                      },
                                                    })
                                                  : _vm._e(),
                                                _vm.page.network !== "bluesky"
                                                  ? _c(
                                                      "span",
                                                      {
                                                        staticClass:
                                                          "emoji-trigger",
                                                        class: {
                                                          triggered:
                                                            _vm.showEmojiPicker,
                                                        },
                                                        on: {
                                                          click:
                                                            _vm.toggleEmojiPicker,
                                                        },
                                                      },
                                                      [
                                                        _c(
                                                          "svg",
                                                          {
                                                            staticStyle: {
                                                              width: "20px",
                                                              height: "20px",
                                                            },
                                                            attrs: {
                                                              viewBox:
                                                                "0 0 24 24",
                                                            },
                                                          },
                                                          [
                                                            _c("path", {
                                                              attrs: {
                                                                fill: "#888888",
                                                                d: "M20,12A8,8 0 0,0 12,4A8,8 0 0,0 4,12A8,8 0 0,0 12,20A8,8 0 0,0 20,12M22,12A10,10 0 0,1 12,22A10,10 0 0,1 2,12A10,10 0 0,1 12,2A10,10 0 0,1 22,12M10,9.5C10,10.3 9.3,11 8.5,11C7.7,11 7,10.3 7,9.5C7,8.7 7.7,8 8.5,8C9.3,8 10,8.7 10,9.5M17,9.5C17,10.3 16.3,11 15.5,11C14.7,11 14,10.3 14,9.5C14,8.7 14.7,8 15.5,8C16.3,8 17,8.7 17,9.5M12,17.23C10.25,17.23 8.71,16.5 7.81,15.42L9.23,14C9.68,14.72 10.75,15.23 12,15.23C13.25,15.23 14.32,14.72 14.77,14L16.19,15.42C15.29,16.5 13.75,17.23 12,17.23Z",
                                                              },
                                                            }),
                                                          ]
                                                        ),
                                                      ]
                                                    )
                                                  : _vm._e(),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass: "add-mention",
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleShowMentions(
                                                          "Mention",
                                                          null,
                                                          idx
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("@")]
                                                ),
                                                _c(
                                                  "span",
                                                  {
                                                    staticClass:
                                                      "add-mention add-hashtag",
                                                    class: {
                                                      disabled:
                                                        !_vm.activeSearchHashtags,
                                                    },
                                                    on: {
                                                      click: function ($event) {
                                                        return _vm.toggleShowMentions(
                                                          "Hashtag",
                                                          null,
                                                          idx
                                                        )
                                                      },
                                                    },
                                                  },
                                                  [_vm._v("#")]
                                                ),
                                                _c("vs-textarea", {
                                                  ref: `inputComment-${idx}-${_vm.page.network_id}`,
                                                  refInFor: true,
                                                  class: { input: true },
                                                  attrs: {
                                                    "vs-size": "large",
                                                    color: "#B20564",
                                                    name: "title",
                                                    placeholder: _vm.$t(
                                                      "dash.posts.overlay.description_placeholder"
                                                    ),
                                                    id: `inputComment-${idx}-${_vm.page.network_id}`,
                                                  },
                                                  on: {
                                                    click: function ($event) {
                                                      ;[
                                                        _vm.checkAddMention(
                                                          null,
                                                          idx
                                                        ),
                                                      ]
                                                    },
                                                    keyup: function ($event) {
                                                      ;[
                                                        _vm.checkAddMention(
                                                          null,
                                                          idx
                                                        ),
                                                        _vm.textAreaAdjust(
                                                          `inputComment-${idx}-${_vm.page.network_id}`
                                                        ),
                                                      ]
                                                    },
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.editValue.comment[
                                                        idx
                                                      ],
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.editValue.comment,
                                                        idx,
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "editValue.comment[idx]",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                  ])
                                : _vm._e(),
                            ]),
                          ],
                          1
                        )
                      }
                    ),
                    0
                  ),
                ]
              )
            : _vm._e(),
          ["facebook", "linkedin", "twitter", "bluesky"].includes(
            _vm.page.network
          ) && _vm.isPreviewLinkInComments()
            ? _c("div", { staticClass: "comments" }, [
                _c("ul", [
                  _c(
                    "li",
                    { staticClass: "comment" },
                    [
                      _c("page-image-avatar", { attrs: { page: _vm.page } }),
                      _c("div", { staticClass: "content" }, [
                        _c("p", { staticClass: "page-name" }, [
                          _vm._v(
                            _vm._s(
                              `${_vm.page.network === "twitter" ? "@" : ""}${
                                _vm.page.name
                              }`
                            )
                          ),
                        ]),
                        _c("p", { staticClass: "message" }, [
                          _c(
                            "a",
                            {
                              attrs: {
                                href: this.getUrlWithUtm,
                                target: "_blank",
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(this.getUrlWithUtm.substr(0, 42)) + "..."
                              ),
                            ]
                          ),
                        ]),
                      ]),
                    ],
                    1
                  ),
                ]),
              ])
            : _vm._e(),
          ["telegram", "instagram", "whatsapp", "bluesky"].includes(
            _vm.page.network
          )
            ? _c(
                "div",
                {
                  class: [
                    {
                      "bottom-right": _vm.page.network === "telegram",
                      "bottom-left": ["instagram", "whatsapp"].includes(
                        _vm.page.network
                      ),
                      live: _vm.live,
                    },
                  ],
                },
                [
                  !_vm.moderation && _vm.page.network === "telegram"
                    ? _c("div", { staticClass: "cta" }, [
                        _c(
                          "svg",
                          {
                            attrs: {
                              "enable-background": "new 0 0 32 32",
                              id: "Editable-line",
                              version: "1.1",
                              viewBox: "0 0 32 32",
                              "xml:space": "preserve",
                              xmlns: "http://www.w3.org/2000/svg",
                              "xmlns:xlink": "http://www.w3.org/1999/xlink",
                            },
                          },
                          [
                            _c("path", {
                              attrs: {
                                d: "  M16,7C9.934,7,4.798,10.776,3,16c1.798,5.224,6.934,9,13,9s11.202-3.776,13-9C27.202,10.776,22.066,7,16,7z",
                                fill: "#B8B8B8",
                                id: "XMLID_10_",
                                stroke: "#B8B8B8",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-miterlimit": "10",
                                "stroke-width": "2",
                              },
                            }),
                            _c("circle", {
                              attrs: {
                                cx: "16",
                                cy: "16",
                                fill: "none",
                                id: "XMLID_12_",
                                r: "5",
                                stroke: "white",
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-miterlimit": "10",
                                "stroke-width": "2",
                              },
                            }),
                          ]
                        ),
                        _c("span", { staticClass: "telegram-view" }, [
                          _vm._v("1"),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.moderation
                    ? _c(
                        "p",
                        { staticClass: "date" },
                        [
                          _c(
                            "Tooltip",
                            {
                              attrs: {
                                text: _vm.dateFormat(_vm.post.date),
                                position: "top",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.dateFromNow(_vm.post.date))),
                              ]),
                              _vm._v("\n           \n        "),
                            ]
                          ),
                        ],
                        1
                      )
                    : _c(
                        "p",
                        {
                          staticClass: "date",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.live &&
                              !_vm.activeEdit.scheduling &&
                              _vm.isUserPremiumActive
                                ? _vm.showEditPost("scheduling")
                                : null
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n      " + _vm._s(_vm.postDate) + "\n      "
                          ),
                          _vm.live && !_vm.doScreenshot
                            ? _c(
                                "span",
                                { staticClass: "btn-edit" },
                                [
                                  _c(
                                    "Tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t(
                                          "dash.post.overlay.edit.date"
                                        ),
                                        position: "top",
                                      },
                                    },
                                    [
                                      _c("vs-button", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.live &&
                                              !_vm.activeEdit.scheduling &&
                                              _vm.isUserPremiumActive,
                                            expression:
                                              "live && !activeEdit.scheduling && isUserPremiumActive",
                                          },
                                        ],
                                        attrs: {
                                          "vs-type": "filled",
                                          icon: "edit",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.showEditPost(
                                              "scheduling"
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v("\n            \n        "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      ),
                  _vm.live && _vm.activeEdit.scheduling
                    ? _c("div", { staticClass: "live-scheduling schedule" }, [
                        _c("div", { staticClass: "schedule-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "edit-scheduling" },
                            [
                              _c("component-datepicker", {
                                staticClass: "posts-datepicker",
                                attrs: {
                                  date: new Date(_vm.editValue.scheduling.date),
                                  now: true,
                                },
                                on: { picked: _vm.picked },
                              }),
                              _c(
                                "div",
                                { staticClass: "posts-timepicker" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/img/icon_time_black.svg"),
                                      alt: "time",
                                    },
                                  }),
                                  _c("vue-timepicker", {
                                    attrs: {
                                      "hour-range": _vm.rangeHour,
                                      "minute-range": _vm.rangeMinute,
                                      "auto-scroll": "",
                                      "minute-interval": _vm.minuteInterval,
                                    },
                                    on: {
                                      change: _vm.changeRangeSchedulingTime,
                                    },
                                    model: {
                                      value: _vm.editValue.scheduling.time,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editValue.scheduling,
                                          "time",
                                          $$v
                                        )
                                      },
                                      expression: "editValue.scheduling.time",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("vs-button", {
                                attrs: { "vs-type": "filled", icon: "close" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.activeEdit.scheduling = false
                                  },
                                },
                              }),
                              _c("vs-button", {
                                attrs: { "vs-type": "filled", icon: "check" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.editPost("scheduling")
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.page.network === "bluesky" &&
                  !_vm.moderation &&
                  !_vm.disableCTA
                    ? _c(
                        "div",
                        { staticClass: "cta" },
                        [
                          [
                            _c(
                              "svg",
                              {
                                staticStyle: {
                                  color: "rgb(111, 134, 159)",
                                  "pointer-events": "none",
                                },
                                attrs: {
                                  fill: "none",
                                  width: "18",
                                  viewBox: "0 0 24 24",
                                  height: "18",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "hsl(211, 20%, 53%)",
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M2.002 6a3 3 0 0 1 3-3h14a3 3 0 0 1 3 3v10a3 3 0 0 1-3 3H12.28l-4.762 2.858A1 1 0 0 1 6.002 21v-2h-1a3 3 0 0 1-3-3V6Zm3-1a1 1 0 0 0-1 1v10a1 1 0 0 0 1 1h2a1 1 0 0 1 1 1v1.234l3.486-2.092a1 1 0 0 1 .514-.142h7a1 1 0 0 0 1-1V6a1 1 0 0 0-1-1h-14Z",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "svg",
                              {
                                staticStyle: { color: "rgb(111, 134, 159)" },
                                attrs: {
                                  fill: "none",
                                  width: "18",
                                  viewBox: "0 0 24 24",
                                  height: "18",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "hsl(211, 20%, 53%)",
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M17.957 2.293a1 1 0 1 0-1.414 1.414L17.836 5H6a3 3 0 0 0-3 3v3a1 1 0 1 0 2 0V8a1 1 0 0 1 1-1h11.836l-1.293 1.293a1 1 0 0 0 1.414 1.414l2.47-2.47a1.75 1.75 0 0 0 0-2.474l-2.47-2.47ZM20 12a1 1 0 0 1 1 1v3a3 3 0 0 1-3 3H6.164l1.293 1.293a1 1 0 1 1-1.414 1.414l-2.47-2.47a1.75 1.75 0 0 1 0-2.474l2.47-2.47a1 1 0 0 1 1.414 1.414L6.164 17H18a1 1 0 0 0 1-1v-3a1 1 0 0 1 1-1Z",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "svg",
                              {
                                staticStyle: {
                                  color: "rgb(111, 134, 159)",
                                  "pointer-events": "none",
                                },
                                attrs: {
                                  fill: "none",
                                  width: "18",
                                  viewBox: "0 0 24 24",
                                  height: "18",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "hsl(211, 20%, 53%)",
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M16.734 5.091c-1.238-.276-2.708.047-4.022 1.38a1 1 0 0 1-1.424 0C9.974 5.137 8.504 4.814 7.266 5.09c-1.263.282-2.379 1.206-2.92 2.556C3.33 10.18 4.252 14.84 12 19.348c7.747-4.508 8.67-9.168 7.654-11.7-.541-1.351-1.657-2.275-2.92-2.557Zm4.777 1.812c1.604 4-.494 9.69-9.022 14.47a1 1 0 0 1-.978 0C2.983 16.592.885 10.902 2.49 6.902c.779-1.942 2.414-3.334 4.342-3.764 1.697-.378 3.552.003 5.169 1.286 1.617-1.283 3.472-1.664 5.17-1.286 1.927.43 3.562 1.822 4.34 3.764Z",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "svg",
                              {
                                staticStyle: {
                                  color: "rgb(111, 134, 159)",
                                  "pointer-events": "none",
                                },
                                attrs: {
                                  fill: "none",
                                  width: "18",
                                  viewBox: "0 0 24 24",
                                  height: "18",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "hsl(211, 20%, 53%)",
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M12.707 3.293a1 1 0 0 0-1.414 0l-4.5 4.5a1 1 0 0 0 1.414 1.414L11 6.414v8.836a1 1 0 1 0 2 0V6.414l2.793 2.793a1 1 0 1 0 1.414-1.414l-4.5-4.5ZM5 12.75a1 1 0 1 0-2 0V20a1 1 0 0 0 1 1h16a1 1 0 0 0 1-1v-7.25a1 1 0 1 0-2 0V19H5v-6.25Z",
                                  },
                                }),
                              ]
                            ),
                            _c(
                              "svg",
                              {
                                staticStyle: { "pointer-events": "none" },
                                attrs: {
                                  fill: "none",
                                  viewBox: "0 0 24 24",
                                  width: "18",
                                  height: "18",
                                },
                              },
                              [
                                _c("path", {
                                  attrs: {
                                    fill: "hsl(211, 20%, 53%)",
                                    "fill-rule": "evenodd",
                                    "clip-rule": "evenodd",
                                    d: "M2 12a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm16 0a2 2 0 1 1 4 0 2 2 0 0 1-4 0Zm-6-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Z",
                                  },
                                }),
                              ]
                            ),
                          ],
                        ],
                        2
                      )
                    : _vm._e(),
                  _vm.page.network === "instagram" &&
                  _vm.shareAfterPost &&
                  _vm.page.story_config &&
                  _vm.page.story_config.created
                    ? _c(
                        "div",
                        [
                          _vm._m(3),
                          _c("story", {
                            class: !_vm.live && "storification-preview-size",
                            attrs: {
                              storification: {
                                video:
                                  (_vm.post.video &&
                                    !(
                                      _vm.multipleMedias &&
                                      _vm.multipleMedias.length > 1
                                    )) ||
                                  (_vm.multipleMedias &&
                                    _vm.multipleMedias[0] &&
                                    _vm.multipleMedias[0].type.includes(
                                      "video"
                                    ) &&
                                    _vm.multipleMedias[0].url),
                                image:
                                  (_vm.multipleMedias &&
                                    _vm.multipleMedias[0] &&
                                    _vm.multipleMedias[0].type.includes(
                                      "image"
                                    ) &&
                                    _vm.multipleMedias[0].url) ||
                                  (_vm.carouselData &&
                                    _vm.carouselData[0] &&
                                    _vm.carouselData[0].url) ||
                                  _vm.post.enclosure ||
                                  _vm.image ||
                                  (_vm.meta &&
                                    _vm.meta.og &&
                                    _vm.meta.og.image) ||
                                  (_vm.meta &&
                                    _vm.meta.og &&
                                    _vm.meta.og.images &&
                                    _vm.meta.images[0] &&
                                    _vm.meta.images[0].url) ||
                                  (_vm.meta &&
                                    _vm.meta.images &&
                                    _vm.meta.images[0] &&
                                    _vm.meta.images[0].url),
                                username: _vm.page.name,
                                isCarousel:
                                  (_vm.multipleImages &&
                                    _vm.multipleImages.length > 1) ||
                                  (_vm.carouselData &&
                                    _vm.carouselData.length > 1) ||
                                  (_vm.multipleMedias &&
                                    _vm.multipleMedias.length > 1 &&
                                    !_vm.multipleMedias[0].type.includes(
                                      "video"
                                    )),
                              },
                              backgroundColor:
                                _vm.$store.getters.storificationBackgroundColor,
                              link: {
                                url: _vm.post.url,
                                initialDatas:
                                  _vm.$store.getters.storificationLink,
                                isActive:
                                  _vm.$store.getters.storificationLinkIsActive,
                                text: _vm.$store.getters.storificationLinkText,
                              },
                              texts: _vm.$store.getters.storificationTexts,
                              layers: _vm.$store.getters.storificationLayers,
                              gifs: _vm.$store.getters.storificationGifs,
                              music: _vm.$store.getters.storificationMusic,
                              location:
                                _vm.$store.getters.storificationLocation,
                              product: _vm.$store.getters.storificationProduct,
                              poll: _vm.$store.getters.storificationPoll,
                              slider: _vm.$store.getters.storificationSlider,
                              mentions:
                                _vm.$store.getters.storificationMentions,
                              hashtags:
                                _vm.$store.getters.storificationHashtags,
                              question:
                                _vm.$store.getters.storificationQuestion,
                              template: {
                                config:
                                  _vm.$store.getters.storificationTemplate,
                                custom: _vm.currentBot
                                  ? _vm.currentBot.storyTemplate
                                  : null,
                              },
                              preview:
                                _vm.live && _vm.index === 0
                                  ? null
                                  : {
                                      Link: _vm.$store.getters
                                        .storificationLink,
                                      Text: _vm.$store.getters
                                        .storificationTexts,
                                      Layer:
                                        _vm.$store.getters.storificationLayers,
                                      Gif: _vm.$store.getters.storificationGifs,
                                      Poll: _vm.$store.getters
                                        .storificationPoll,
                                      Slider:
                                        _vm.$store.getters.storificationSlider,
                                      Mention:
                                        _vm.$store.getters
                                          .storificationMentions,
                                      Hashtag:
                                        _vm.$store.getters
                                          .storificationHashtags,
                                      Location:
                                        _vm.$store.getters
                                          .storificationLocation,
                                      Product:
                                        _vm.$store.getters.storificationProduct,
                                      Question:
                                        _vm.$store.getters
                                          .storificationQuestion,
                                    },
                              informations: {
                                mentions: _vm.currentBot,
                                acceptReplaceHashtag: _vm.activeHashtagsAutoAdd,
                                validMentions: _vm.validMentions,
                                validHashtags: _vm.validHashtags,
                                acceptPrefix: _vm.activePrefixSuffix,
                                pageInfo: _vm.page,
                                highlight: _vm.highlightStoryEnable,
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.page.network === "instagram" &&
                  _vm.shareAfterPost &&
                  _vm.page.story_config &&
                  _vm.page.story_config.created
                    ? _c(
                        "p",
                        {
                          staticClass: "date",
                          on: {
                            click: function ($event) {
                              $event.preventDefault()
                              _vm.live &&
                              !_vm.activeEdit.scheduling &&
                              _vm.isUserPremiumActive
                                ? _vm.showEditPost("scheduling")
                                : null
                            },
                          },
                        },
                        [
                          _vm._v(
                            "\n      " +
                              _vm._s(_vm.postDateStorification) +
                              "\n      "
                          ),
                          _vm.live && !_vm.doScreenshot
                            ? _c(
                                "span",
                                { staticClass: "btn-edit" },
                                [
                                  _c(
                                    "Tooltip",
                                    {
                                      attrs: {
                                        text: _vm.$t(
                                          "dash.post.overlay.edit.date"
                                        ),
                                        position: "top",
                                      },
                                    },
                                    [
                                      _c("vs-button", {
                                        directives: [
                                          {
                                            name: "show",
                                            rawName: "v-show",
                                            value:
                                              _vm.live &&
                                              !_vm.activeEdit.scheduling &&
                                              _vm.isUserPremiumActive,
                                            expression:
                                              "live && !activeEdit.scheduling && isUserPremiumActive",
                                          },
                                        ],
                                        attrs: {
                                          "vs-type": "filled",
                                          icon: "edit",
                                        },
                                        on: {
                                          click: function ($event) {
                                            $event.preventDefault()
                                            return _vm.showEditPost(
                                              "scheduling"
                                            )
                                          },
                                        },
                                      }),
                                      _vm._v("\n            \n        "),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              )
                            : _vm._e(),
                        ]
                      )
                    : _vm._e(),
                  _vm.live &&
                  _vm.activeEdit.scheduling &&
                  _vm.page.network === "instagram" &&
                  _vm.shareAfterPost &&
                  _vm.page.story_config &&
                  _vm.page.story_config.created
                    ? _c("div", { staticClass: "live-scheduling schedule" }, [
                        _c("div", { staticClass: "schedule-wrapper" }, [
                          _c(
                            "div",
                            { staticClass: "edit-scheduling" },
                            [
                              _c("component-datepicker", {
                                staticClass: "posts-datepicker",
                                attrs: {
                                  top: true,
                                  date: new Date(
                                    _vm.editValue.storification.date
                                  ),
                                  from: new Date(_vm.editValue.scheduling.date),
                                },
                                on: { picked: (d) => _vm.picked(d, true) },
                              }),
                              _c(
                                "div",
                                {
                                  staticClass: "posts-timepicker storification",
                                },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: require("../../assets/img/icon_time_black.svg"),
                                      alt: "time",
                                    },
                                  }),
                                  _c("vue-timepicker", {
                                    attrs: {
                                      "drop-direction": "up",
                                      "hour-range": _vm.rangeHourStorification,
                                      "minute-range":
                                        _vm.rangeMinuteStorification,
                                      "auto-scroll": "",
                                      "minute-interval": _vm.minuteInterval,
                                    },
                                    on: {
                                      change:
                                        _vm.changeRangeSchedulingTimeStorification,
                                    },
                                    model: {
                                      value: _vm.editValue.storification.time,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.editValue.storification,
                                          "time",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "editValue.storification.time",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c("vs-button", {
                                attrs: { "vs-type": "filled", icon: "close" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    _vm.activeEdit.scheduling = false
                                  },
                                },
                              }),
                              _c("vs-button", {
                                attrs: { "vs-type": "filled", icon: "check" },
                                on: {
                                  click: function ($event) {
                                    $event.preventDefault()
                                    return _vm.editPost("scheduling", true)
                                  },
                                },
                              }),
                            ],
                            1
                          ),
                        ]),
                      ])
                    : _vm._e(),
                  _vm.page.network === "instagram" &&
                  _vm.storyShareToFacebook &&
                  _vm.page.story_config &&
                  _vm.page.story_config.created
                    ? _c(
                        "div",
                        [
                          _vm._m(4),
                          _c("story", {
                            class: !_vm.live && "storification-preview-size",
                            attrs: {
                              story: !(
                                _vm.storificationObject || _vm.shareAfterPost
                              )
                                ? {
                                    image: _vm.imageStory,
                                    video: _vm.videoStory,
                                  }
                                : undefined,
                              storification:
                                _vm.storificationObject || _vm.shareAfterPost
                                  ? {
                                      video:
                                        (_vm.post.video &&
                                          !(
                                            _vm.multipleMedias &&
                                            _vm.multipleMedias.length > 1
                                          )) ||
                                        (_vm.multipleMedias &&
                                          _vm.multipleMedias[0] &&
                                          _vm.multipleMedias[0].type.includes(
                                            "video"
                                          ) &&
                                          _vm.multipleMedias[0].url),
                                      image:
                                        (_vm.multipleMedias &&
                                          _vm.multipleMedias[0] &&
                                          _vm.multipleMedias[0].type.includes(
                                            "image"
                                          ) &&
                                          _vm.multipleMedias[0].url) ||
                                        (_vm.carouselData &&
                                          _vm.carouselData[0] &&
                                          _vm.carouselData[0].url) ||
                                        _vm.post.enclosure ||
                                        _vm.image ||
                                        (_vm.meta &&
                                          _vm.meta.og &&
                                          _vm.meta.og.image) ||
                                        (_vm.meta &&
                                          _vm.meta.og &&
                                          _vm.meta.og.images &&
                                          _vm.meta.images[0] &&
                                          _vm.meta.images[0].url) ||
                                        (_vm.meta &&
                                          _vm.meta.images &&
                                          _vm.meta.images[0] &&
                                          _vm.meta.images[0].url),
                                      username: _vm.page.name,
                                      isCarousel:
                                        (_vm.multipleImages &&
                                          _vm.multipleImages.length > 1) ||
                                        (_vm.carouselData &&
                                          _vm.carouselData.length > 1) ||
                                        (_vm.multipleMedias &&
                                          _vm.multipleMedias.length > 1 &&
                                          !_vm.multipleMedias[0].type.includes(
                                            "video"
                                          )),
                                    }
                                  : undefined,
                              backgroundColor:
                                _vm.$store.getters.storificationBackgroundColor,
                              link: {
                                url: _vm.post.url,
                                initialDatas:
                                  _vm.$store.getters.storificationLink,
                                isActive:
                                  _vm.$store.getters.storificationLinkIsActive,
                                text: _vm.$store.getters.storificationLinkText,
                              },
                              texts: _vm.$store.getters.storificationTexts,
                              layers: _vm.$store.getters.storificationLayers,
                              gifs: _vm.$store.getters.storificationGifs,
                              location:
                                _vm.$store.getters.storificationLocation,
                              product: _vm.$store.getters.storificationProduct,
                              music: _vm.$store.getters.storificationMusic,
                              poll: _vm.$store.getters.storificationPoll,
                              slider: _vm.$store.getters.storificationSlider,
                              mentions:
                                _vm.$store.getters.storificationMentions,
                              hashtags:
                                _vm.$store.getters.storificationHashtags,
                              question:
                                _vm.$store.getters.storificationQuestion,
                              template: {
                                config:
                                  _vm.$store.getters.storificationTemplate,
                                custom: _vm.currentBot
                                  ? _vm.currentBot.storyTemplate
                                  : null,
                              },
                              preview: {
                                Link: _vm.$store.getters.storificationLink,
                                Text: _vm.$store.getters.storificationTexts,
                                Layer: _vm.$store.getters.storificationLayers,
                                Gif: _vm.$store.getters.storificationGifs,
                                Poll: _vm.$store.getters.storificationPoll,
                                Slider: _vm.$store.getters.storificationSlider,
                                Mention:
                                  _vm.$store.getters.storificationMentions,
                                Hashtag:
                                  _vm.$store.getters.storificationHashtags,
                                Location:
                                  _vm.$store.getters.storificationLocation,
                                Product:
                                  _vm.$store.getters.storificationProduct,
                                Question:
                                  _vm.$store.getters.storificationQuestion,
                              },
                              informations: {
                                mentions: _vm.currentBot,
                                acceptReplaceHashtag: _vm.activeHashtagsAutoAdd,
                                validMentions: _vm.validMentions,
                                validHashtags: _vm.validHashtags,
                                acceptPrefix: _vm.activePrefixSuffix,
                                pageInfo: _vm.page,
                                highlight: _vm.highlightStoryEnable,
                              },
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm.page.network === "instagram" &&
                  _vm.shareAfterPost &&
                  _vm.storyShareToFacebook &&
                  _vm.page.story_config &&
                  _vm.page.story_config.created
                    ? _c("p", { staticClass: "date" }, [
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.postDateStorification) +
                            "\n    "
                        ),
                      ])
                    : _vm._e(),
                ]
              )
            : _vm._e(),
          _vm.live
            ? _c(
                "vs-prompt",
                {
                  staticClass: "auto-generate-text",
                  attrs: {
                    title: _vm.$t("dash.auto-generate-text.title"),
                    color: "info",
                    active: _vm.openAccrochesAI,
                  },
                  on: {
                    cancel: () => {
                      _vm.openAccrochesAI = false
                      _vm.accrochesAI = null
                    },
                    accept: function ($event) {
                      return _vm.changeTextByGenerated()
                    },
                    close: () => {
                      _vm.openAccrochesAI = false
                      _vm.accrochesAI = null
                    },
                    "update:active": function ($event) {
                      _vm.openAccrochesAI = $event
                    },
                  },
                },
                [
                  _c("div", { staticClass: "con-exemple-prompt" }, [
                    _c(
                      "ul",
                      _vm._l(_vm.accrochesAI, function (opt, idx) {
                        return _c("li", { key: idx }, [
                          _c("input", {
                            directives: [
                              {
                                name: "model",
                                rawName: "v-model",
                                value: _vm.selectedAccroches,
                                expression: "selectedAccroches",
                              },
                            ],
                            attrs: {
                              type: "checkbox",
                              id: `accroche-${idx}`,
                              name: "accroches[]",
                            },
                            domProps: {
                              value: opt,
                              checked: Array.isArray(_vm.selectedAccroches)
                                ? _vm._i(_vm.selectedAccroches, opt) > -1
                                : _vm.selectedAccroches,
                            },
                            on: {
                              change: function ($event) {
                                var $$a = _vm.selectedAccroches,
                                  $$el = $event.target,
                                  $$c = $$el.checked ? true : false
                                if (Array.isArray($$a)) {
                                  var $$v = opt,
                                    $$i = _vm._i($$a, $$v)
                                  if ($$el.checked) {
                                    $$i < 0 &&
                                      (_vm.selectedAccroches = $$a.concat([
                                        $$v,
                                      ]))
                                  } else {
                                    $$i > -1 &&
                                      (_vm.selectedAccroches = $$a
                                        .slice(0, $$i)
                                        .concat($$a.slice($$i + 1)))
                                  }
                                } else {
                                  _vm.selectedAccroches = $$c
                                }
                              },
                            },
                          }),
                          _vm._v("  \n          " + _vm._s(opt) + "\n        "),
                        ])
                      }),
                      0
                    ),
                  ]),
                ]
              )
            : _vm._e(),
        ],
        1
      )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "tiktok-categories" }, [
      _c("span", [_vm._v("Following")]),
      _c("span", [_vm._v("For You")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vertical-line" }, [
      _c("span", [_vm._v("Storification")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vertical-line" }, [
      _c("span", [_vm._v("Facebook")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vertical-line" }, [
      _c("span", [_vm._v("Storification")]),
    ])
  },
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "vertical-line" }, [
      _c("span", [_vm._v("Facebook")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }